import React, { useState, useMemo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { apiCall } from "../../../utils/axiosService";
import { API_URL } from "../../../utils/apiRoutes";
import { apiResponse } from "../../../utils/apiResponse";
import moment from "moment";
import Loader from "../../Loader/Loader";
import { Button, Table, OverlayTrigger, Popover } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import Select from "react-select";
import { commonService } from "../../../utils/commonService";
import ticket from "../../../Assets/Images/Revenue-management/tableTicket.svg";
import EventViewModal from "../../CommonComponent/EventViewModal";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const DOW_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const fmtNum = (n, dec = 0) => {
  if (isNaN(n) || n === null || n === undefined) return "—";
  return Number(n).toLocaleString("en-US", {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  });
};
const fmtPct = (n) => {
  return fmtNum(n, 1) + "%";
};

const UserSimulator = ({ api, para, setting }) => {
  // Navigation & View State
  const curentYear = new Date().getFullYear();
  const [year, setYear] = useState(curentYear);
  const curentMonth = new Date().getMonth();
  const [viewMode, setViewMode] = useState("rooms");
  const [activeMonth, setActiveMonth] = useState(curentMonth);
  const [isDatewise, setIsDatewise] = useState(true);
  const [isDatewiseSTLY, setIsDatewiseSTLY] = useState(true);
  const [isSTLYDatewiseLoading, setIsSTLYDatewiseLoading] = useState(false);
  const [isLYDatewiseLoading, setIsLYDatewiseLoading] = useState(false);
  const [showLY, setShowLY] = useState(false);
  const [selectedYears, setSelectedYears] = useState([]);
  const [showSTLY, setShowSTLY] = useState(false);
  const [activeMainTab, setActiveMainTab] = useState("breakdown");

  // Hidden segments for legends toggle
  const [hiddenSegments, setHiddenSegments] = useState({});
  const [hiddenSegments2, setHiddenSegments2] = useState({});
  const toggleSegment = (key) => {
    setHiddenSegments((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  const toggleSegment2 = (key) => {
    setHiddenSegments2((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail,
  );

  const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyDetailFromRTK?.propertycode || "";
  const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate,
  );
  const asOfDateFromRTK = useSelector((store) => store.headerProperty.asOfDate);

  const currencySign = useMemo(
    () => propertyDetailFromRTK?.currency_term || "$",
    [propertyDetailFromRTK],
  );

  const eventListRef = useRef([]);
  const selectedEventDateRef = useRef(null);
  const eventListPropsRef = useRef([]);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const closeTicketModal = () => {
    setShowTicketModal(false);
  };

  const getEventList = async () => {
    if (api === 0) return;
    let eventList = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.RevenueManagement + API_URL.EVENTS.GET_LIST,
        body: {
          pageNum: 1,
          pageSize: 10,
          sortColumn: "",
          sortDirection: "asc",
          searchValue: "",
          propertyid: parseInt(propertyId),
          startdate: null,
          enddate: null,
          eventname: "",
          eventtypeterm: "",
          yearterm: ``,
        },
      },
      false,
    );

    let eventListResponse = apiResponse(false, eventList);

    if (eventListResponse?.isValidate) {
      let eventListArr = [];
      eventListResponse?.data?.data?.forEach((item) => {
        try {
          let singleEventObj = {
            id: item?.eventid ? item?.eventid : 0,
            name: item?.eventname,
            detail: item?.eventdetails,
            startDate: item?.startdate,
            endDate: item?.enddate,
            eventJson: item?.eventjson,
            eventResourceId: item?.eventsourceid,
          };
          let eventJsonData = "";
          if (item?.eventjson) {
            var decodedString = decodeURIComponent(item?.eventjson);
            const jsonStringWithoutQuotes = decodedString.slice(1, -1);
            const jsonStringWithSingleQuotes = `${jsonStringWithoutQuotes}`;
            eventJsonData = JSON.parse(jsonStringWithSingleQuotes);
            let desc = eventJsonData?.description?.replaceAll("+", " ");
            singleEventObj = {
              ...singleEventObj,
              labels: eventJsonData?.labels ? eventJsonData?.labels : "",
              rank: eventJsonData?.rank ? eventJsonData?.rank : 0,
              local_rank: eventJsonData?.local_rank
                ? eventJsonData?.local_rank
                : 0,
              phq_attendance: eventJsonData?.phq_attendance
                ? eventJsonData?.phq_attendance
                : 0,
              geo_lat: eventJsonData?.geo_lat ? eventJsonData?.geo_lat : "",
              geo_long: eventJsonData?.geo_long ? eventJsonData?.geo_long : "",
              detail: desc,
            };
          }
          eventListArr.push(singleEventObj);
        } catch (err) {}
      });
      eventListRef.current = eventListArr;
    }

    if (!eventListResponse?.isValidate) {
      eventListRef.current = [];
    }
  };

  useEffect(() => {
    if (api === 0) return;
    if (propertyId) {
      getEventList();
    }
  }, [propertyId, api]);

  const currentProperty = useMemo(() => {
    let occ = 0.72; // default fallback
    let adr = 139; // default fallback
    let rooms = 126; // default fallback

    if (propertyDetailFromRTK?.revenuconfig?.[0]) {
      const config = propertyDetailFromRTK.revenuconfig[0];
      rooms = config.totalrooms || 0;

      try {
        if (config.occupancyjson) {
          const parsedOcc = JSON.parse(config.occupancyjson);
          if (parsedOcc && parsedOcc.value !== undefined) {
            occ = parsedOcc.value / 100;
          }
        }
      } catch (e) {
      }

      try {
        if (config.adrjson) {
          const parsedAdr = JSON.parse(config.adrjson);
          if (parsedAdr && parsedAdr.value !== undefined) {
            adr = parsedAdr.value;
          }
        }
      } catch (e) {
      }
    }

    return {
      name: propertyDetailFromRTK?.propertycode || "CHIZI",
      rooms: rooms,
      sysOcc: occ,
      sysADR: adr,
    };
  }, [propertyDetailFromRTK]);

  // ORG actuals state & API fetch
  const [apiOrgData, setApiOrgData] = useState([]);
  const [apiOrgLoading, setApiOrgLoading] = useState(true);

  const fetchOrgData = async (years) => {
    if (api === 0) return setApiOrgLoading(false);
    if (!propertyCode) return setApiOrgLoading(false);
    if (!asOfDateFromRTK && !defaultAsOfDateFromRTK)
      return setApiOrgLoading(false);

    setApiOrgLoading(true);
    try {
      const tzStart = commonService.convertDateInTimezone(new Date(year, 0, 1));
      const tzEnd = commonService.convertDateInTimezone(new Date(year, 11, 31));
      const startDatePayload = commonService.getDateForNode(tzStart);
      const endDatePayload = commonService.getDateForNode(tzEnd);

      let orgDataResponse = await apiCall(
        {
          method: "POST",
          url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
          body: {
            AsOfDate: asOfDateFromRTK || defaultAsOfDateFromRTK || "",
            startDate: startDatePayload,
            endDate: endDatePayload,
            propertyCode: propertyCode,
            propertyid: parseInt(propertyId),
          },
        },
        false,
      );

      let response = apiResponse(false, orgDataResponse);

      if (response?.isValidate && response?.data?.data) {
        setApiOrgData(response?.data?.data);
      } else {
        setApiOrgData([]);
      }
    } catch (err) {
      setApiOrgData([]);
    } finally {
      setApiOrgLoading(false);
    }
  };

  // Last Year actuals state & API fetch
  const [apiLyData, setApiLyData] = useState([]);
  const [apiLyLoading, setApiLyLoading] = useState(false);

  const fetchLyData = async (years, isChecked) => {
    if (api === 0) return setApiLyLoading(false);
    if (!propertyCode) return setApiLyLoading(false);
    if (!asOfDateFromRTK && !defaultAsOfDateFromRTK)
      return setApiLyLoading(false);

    // setApiLyLoading(true);
    try {
      const yearsToFetch =
        years && years.length > 0 ? years.map((y) => y.value) : [year];

      let _URL = "";
      if (isChecked) {
        _URL =
          API_URL.BASE_API_URL.SnapShot + API_URL.REV_PAK_90_DAY_OUTLOOK.GET_LY;
      } else {
        _URL =
          API_URL.BASE_API_URL.SnapShot +
          API_URL.REV_PAK_90_DAY_OUTLOOK.GET_LY_DATEWISE;
      }

      const promises = yearsToFetch.map(async (y) => {
        const tzStart = commonService.convertDateInTimezone(
          new Date(y + 1, 0, 1),
        );
        const tzEnd = commonService.convertDateInTimezone(
          new Date(y + 1, 11, 31),
        );
        const startDatePayload = commonService.getDateForNode(tzStart);
        const endDatePayload = commonService.getDateForNode(tzEnd);

        let lyDataResponse = await apiCall(
          {
            method: "POST",
            url: _URL,
            body: {
              AsOfDate: asOfDateFromRTK || defaultAsOfDateFromRTK || "",
              startDate: startDatePayload,
              endDate: endDatePayload,
              propertyCode: propertyCode,
              propertyid: parseInt(propertyId),
            },
          },
          false,
        );

        let response = apiResponse(false, lyDataResponse);
        if (response?.isValidate && response?.data?.data) {
          return response.data.data;
        }
        return [];
      });

      const results = await Promise.all(promises);
      const mergedData = results.flat();

      setApiLyData(mergedData);
    } catch (err) {
      setApiLyData([]);
    } finally {
      setApiLyLoading(false);
    }
  };

  const [selectedForecast, setSelectedForecast] = useState(
    propertyDetailFromRTK?.revenuconfig?.[0]?.forcasttype_term
      ? propertyDetailFromRTK.revenuconfig[0].forcasttype_term.toLowerCase()
      : "ema",
  );

  // Forecast data & API fetch
  const [apiLyForecastData, setApiLyForecastData] = useState([]);
  const [apiLyForecastLoading, setApiLyForecastLoading] = useState(true);

  const fetchLyForecastData = async () => {
    if (api === 0) return setApiLyForecastLoading(false);
    if (!propertyCode)
      return setApiLyForecastLoading(false);
    if (!asOfDateFromRTK && !defaultAsOfDateFromRTK)
      return setApiLyForecastLoading(false);

    setApiLyForecastLoading(true);
    try {
      const tzStart = commonService.convertDateInTimezone(new Date(year, 0, 1));
      const tzEnd = commonService.convertDateInTimezone(new Date(year, 11, 31));
      const startDatePayload = commonService.getDateForNode(tzStart);
      const endDatePayload = commonService.getDateForNode(tzEnd);

      let lastYearResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.LAST_YEAR_AND_FORECAST.LAST_YEAR_AND_FORECAST,
          body: {
            AsOfDate: asOfDateFromRTK || defaultAsOfDateFromRTK || "",
            startDate: startDatePayload,
            endDate: endDatePayload,
            propertyCode: propertyCode,
            ForcastType: selectedForecast,
            propertyid: propertyId,
          },
        },
        false,
      );

      let response = apiResponse(false, lastYearResponse);

      if (response?.isValidate && response?.data?.data) {
        setApiLyForecastData(response?.data?.data);
      } else {
        setApiLyForecastData([]);
      }
    } catch (err) {
      setApiLyForecastData([]);
    } finally {
      setApiLyForecastLoading(false);
    }
  };

  // STLY actuals state & API fetch
  const [apiStlyData, setApiStlyData] = useState([]);
  const [apiStlyLoading, setApiStlyLoading] = useState(true);

  const fetchStlyData = async (years, isChecked) => {
    if (api === 0) return;
    if (!propertyCode) return setApiStlyLoading(false);
    if (!asOfDateFromRTK && !defaultAsOfDateFromRTK)
      return setApiStlyLoading(false);

    setApiStlyLoading(true);
    try {
      const tzStart = commonService.convertDateInTimezone(new Date(year, 0, 1));
      const tzEnd = commonService.convertDateInTimezone(new Date(year, 11, 31));
      const startDatePayload = commonService.getDateForNode(tzStart);
      const endDatePayload = commonService.getDateForNode(tzEnd);

      let _URL = "";
      if (isChecked) {
        _URL =
          API_URL.BASE_API_URL.SnapShot +
          API_URL.REV_PAK_90_DAY_OUTLOOK.GET_NET_STLY;
      } else {
        _URL =
          API_URL.BASE_API_URL.SnapShot +
          API_URL.REV_PAK_90_DAY_OUTLOOK.GET_NET_STLY_DATEWISE;
      }

      let stlyDataResponse = await apiCall(
        {
          method: "POST",
          url: _URL,
          body: {
            AsOfDate: asOfDateFromRTK || defaultAsOfDateFromRTK || "",
            startDate: startDatePayload,
            endDate: endDatePayload,
            propertyCode: propertyCode,
            propertyid: parseInt(propertyId),
          },
        },
        false,
      );

      let response = apiResponse(false, stlyDataResponse);

      if (response?.isValidate && response?.data?.data) {
        setApiStlyData(response?.data?.data);
      } else {
        setApiStlyData([]);
      }
    } catch (err) {
      setApiStlyData([]);
    } finally {
      setApiStlyLoading(false);
    }
  };

  useEffect(() => {
    if (api === 0) return;
    fetchOrgData();
    // fetchLyData();
    // fetchStlyData();
    fetchLyForecastData();
  }, [
    year,
    propertyCode,
    propertyId,
    api,
    asOfDateFromRTK,
    defaultAsOfDateFromRTK,
    selectedForecast,
  ]);

  // Budget Save actuals state & handler
  const [saveLoading, setSaveLoading] = useState(false);

  const handleSave = async () => {
    if (api === 0) return;
    if (!propertyId) return;
    setSaveLoading(true);

    const updatedArray = [];
    const updatedTotalArray = [];

    activeMonthRows.forEach((r) => {
      const dayDate = new Date(year, activeMonth, r.day);
      const dbDate = commonService.getDateInDBFormat(dayDate);

      segments.forEach((seg) => {
        updatedArray.push({
          propertyid: parseInt(propertyId),
          marketsegment_term: seg.label,
          forecastdate: dbDate,
          actualoccupency: r.paidRooms || 0,
          actualrevenue: r.rev || 0,
          roomsold: r.segs[seg.key]?.rooms || 0,
          revenue: r.segs[seg.key]?.rev || 0,
          adr: 0,
          actualadr: 0,
          totalrooms: 0,
          totalrevenue: 0,
        });
      });
    });

    segments.forEach((seg) => {
      let totalActualOcc = 0;
      let totalActualRev = 0;
      let totalOcc = 0;
      let totalRev = 0;

      activeMonthRows.forEach((r) => {
        totalActualOcc += r.paidRooms || 0;
        totalActualRev += r.rev || 0;
        totalOcc += r.segs[seg.key]?.rooms || 0;
        totalRev += r.segs[seg.key]?.rev || 0;
      });

      updatedTotalArray.push({
        propertyid: parseInt(propertyId),
        marketsegment_term: seg.label,
        actualoccupency: totalActualOcc,
        actualrevenue: totalActualRev,
        roomsold: totalOcc,
        revenue: totalRev,
        adr: 0,
        actualadr: 0,
        totalrooms: 0,
        totalrevenue: 0,
      });
    });

    const payload = {
      propertyid: parseInt(propertyId),
      year_term: year.toString(),
      month_term: (activeMonth + 1).toString(),
      forecasttype_term: "User Forecast",
      ForecastData: updatedArray,
      ForecastTotal: updatedTotalArray,
    };

    try {
      const saveResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.RevenueManagement +
            API_URL.REVENUE_FORE_CAST.SAVEBYDATEWITHTOTAL,
          body: payload,
        },
        true,
      );

      apiResponse(true, saveResponse, setSaveLoading);
    } catch (err) {
      
    } finally {
      setSaveLoading(false);
    }
  };

  const fmtDollar = (n, dec = 0) => {
    if (isNaN(n) || n === null || n === undefined) return "—";
    if (dec === 0) {
      return commonService.formateAmount(n, currencySign);
    }
    return currencySign + fmtNum(n, dec);
  };

  const [segments, setSegments] = useState([]);
  const [segFilter, setSegFilter] = useState("all");
  const [segOptions, setSegOptions] = useState([
    { label: "All Segments", value: "all" },
  ]);

  const getMarketSegmentData = async () => {
    if (api === 0) return;
    if (!propertyId) return;
    try {
      let marketSegmentDataResponse = await apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.Configuration +
            API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY_AND_PROPERTY,
          body: {
            categorynamebycomma: "Market Segment",
            propertyid: parseInt(propertyId),
          },
        },
        false,
      );

      let response = apiResponse(false, marketSegmentDataResponse);

      if (response?.isValidate && response?.data?.data) {
        const loadedSegs = response.data.data.map((item, index) => {
          const term = item.term;
          const lower = term.toLowerCase();
          let key = lower.replace(/[^a-z0-9]/g, "");
          if (!key) key = `seg${index}`;

          let category = "other";
          if (lower.includes("corp")) category = "corp";
          else if (
            lower.includes("leisure") ||
            lower.includes("transient") ||
            lower.includes("lei")
          )
            category = "lei";
          else if (
            lower.includes("group") ||
            lower.includes("meeting") ||
            lower.includes("grp")
          )
            category = "grp";
          else if (lower.includes("gov") || lower.includes("state"))
            category = "gov";
          else if (lower.includes("ota") || lower.includes("online"))
            category = "ota";

          const defaultColor = commonService.getColorByCategory(key);
          return {
            key,
            label: term,
            category,
            color: defaultColor.color,
            light: defaultColor.light,
          };
        });

        if (loadedSegs.length > 0) {
          setSegments(loadedSegs);
          const lst = [
            { label: "All Segments", value: "all" },
            ...loadedSegs.map((s) => ({ label: s.label, value: s.key })),
          ];
          setSegOptions(lst);

          const initialMix = {};
          loadedSegs.forEach((seg) => {
            initialMix[seg.key] = Number((100 / loadedSegs.length).toFixed(1));
          });
          setMix(initialMix);
        }
      }
    } catch (err) {
    }
  };

  useEffect(() => {
    if (api === 0) return;
    getMarketSegmentData();
  }, [propertyId, api]);

  // Configuration Inputs

  // Forecast Drivers
  const [occAdj, setOccAdj] = useState(0);
  const [paceAdj, setPaceAdj] = useState(0);
  const [adrAdj, setAdrAdj] = useState(0);

  // Signal Weighting
  const [wStly, setWStly] = useState(30);
  const [wLy, setWLy] = useState(20);
  const [wPace, setWPace] = useState(25);

  // Local state for UI responsiveness (Debouncing)
  const [localOccAdj, setLocalOccAdj] = useState(0);
  const [localPaceAdj, setLocalPaceAdj] = useState(0);
  const [localAdrAdj, setLocalAdrAdj] = useState(0);
  const [localWStly, setLocalWStly] = useState(30);
  const [localWLy, setLocalWLy] = useState(20);
  const [localWPace, setLocalWPace] = useState(25);

  useEffect(() => {
    if (api === 0) return;
    const timer = setTimeout(() => {
      setOccAdj(localOccAdj);
      setPaceAdj(localPaceAdj);
      setAdrAdj(localAdrAdj);
      setWStly(localWStly);
      setWLy(localWLy);
      setWPace(localWPace);
    }, 500);
    return () => clearTimeout(timer);
  }, [
    localOccAdj,
    localPaceAdj,
    localAdrAdj,
    localWStly,
    localWLy,
    localWPace,
  ]);

  const [mix, setMix] = useState({});
  const [segmentOverrides, setSegmentOverrides] = useState({});
  const [dayOverrides, setDayOverrides] = useState({});
  const [totalOverrides, setTotalOverrides] = useState({});

  const handleTotalEdit = (monthIdx, field, value) => {
    setTotalOverrides((prev) => {
      const monthData = prev[monthIdx] || {};
      const val = value === "" ? "" : Number(value);
      return {
        ...prev,
        [monthIdx]: {
          ...monthData,
          [field]: val,
        },
      };
    });
  };

  const handleDayEdit = (monthIdx, day, field, value) => {
    setDayOverrides((prev) => {
      const monthData = prev[monthIdx] || {};
      const dayData = monthData[day] || {};
      const val = value === "" ? "" : Number(value);
      const newDayData = { ...dayData, [field]: val };

      return {
        ...prev,
        [monthIdx]: {
          ...monthData,
          [day]: newDayData,
        },
      };
    });

    setTotalOverrides((prev) => {
      const monthData = prev[monthIdx];
      if (!monthData) return prev;
      const newMonthData = { ...monthData };
      if (field === "paidRooms" && newMonthData.paidRooms !== undefined)
        delete newMonthData.paidRooms;
      if (field === "occ" && newMonthData.occ !== undefined)
        delete newMonthData.occ;
      if (field === "rev" && newMonthData.rev !== undefined)
        delete newMonthData.rev;
      if (field === "adr" && newMonthData.adr !== undefined)
        delete newMonthData.adr;
      return { ...prev, [monthIdx]: newMonthData };
    });
  };

  const handleSegmentEdit = (monthIdx, day, segKey, field, value) => {
    setSegmentOverrides((prev) => {
      const monthData = prev[monthIdx] || {};
      const dayData = monthData[day] || {};
      const segData = dayData[segKey] || {};

      // If value is empty string, we keep it as empty string so input can be cleared
      const val = value === "" ? "" : Number(value);

      const newSegData = { ...segData, [field]: val };

      // Optional convenience: auto-calculate REV if RMS or ADR is edited
      if (field === "rooms" && segData.adr !== undefined && val !== "") {
        newSegData.rev = val * segData.adr;
      } else if (field === "adr" && segData.rooms !== undefined && val !== "") {
        newSegData.rev = val * segData.rooms;
      }

      return {
        ...prev,
        [monthIdx]: {
          ...monthData,
          [day]: {
            ...dayData,
            [segKey]: newSegData,
          },
        },
      };
    });

    setTotalOverrides((prev) => {
      const monthData = prev[monthIdx];
      if (!monthData) return prev;
      const newMonthData = { ...monthData };

      const fieldRooms = `seg_${segKey}_rooms`;
      const fieldRev = `seg_${segKey}_rev`;
      const fieldAdr = `seg_${segKey}_adr`;

      if (field === "rooms") {
        delete newMonthData[fieldRooms];
        delete newMonthData[fieldRev];
      } else if (field === "adr") {
        delete newMonthData[fieldAdr];
        delete newMonthData[fieldRev];
      } else if (field === "rev") {
        delete newMonthData[fieldRev];
        delete newMonthData[fieldAdr];
      }

      return { ...prev, [monthIdx]: newMonthData };
    });
  };

  const resetDrivers = () => {
    if (api === 0) return;
    setLocalOccAdj(0);
    setLocalPaceAdj(0);
    setLocalAdrAdj(0);
    setLocalWStly(30);
    setLocalWLy(20);
    setLocalWPace(25);
  };

  const handleMixChange = (key, val) => {
    setMix((prev) => ({
      ...prev,
      [key]: parseFloat(val) || 0,
    }));
  };

  // Calculation Engine
  const monthBase = (month, inputs, variant) => {
    const p = inputs.currentProperty;
    const sysOcc = p.sysOcc;
    const stlyOcc = sysOcc * 0.97;
    const lyOcc = sysOcc * 0.95;
    const paceOcc = sysOcc * (1 + inputs.paceAdj * 0.6);

    if (variant === "stly")
      return {
        occ: Math.min(0.98, stlyOcc),
        adr: p.sysADR * 0.97,
      };
    if (variant === "ly")
      return {
        occ: Math.min(0.98, lyOcc),
        adr: p.sysADR * 0.94,
      };

    const wS = inputs.wStly,
      wL = inputs.wLy,
      wP = inputs.wPace;
    const wSys = Math.max(0, 100 - wS - wL - wP);
    const tot = wSys + wS + wL + wP || 100;
    let occ = (sysOcc * wSys + stlyOcc * wS + lyOcc * wL + paceOcc * wP) / tot;
    occ = occ * (1 + inputs.occAdj);
    occ = Math.min(0.98, occ);
    const adr = p.sysADR * (1 + inputs.adrAdj);
    return { occ, adr };
  };

  const generateDayData = (yearVal, monthVal, inputs) => {
    const p = inputs.currentProperty;
    const days = new Date(yearVal, monthVal + 1, 0).getDate();
    const base = monthBase(monthVal, inputs, "forecast");
    const totalMix =
      Object.values(inputs.mix).reduce((a, b) => a + b, 0) || 100;

    const rows = [];
    for (let d = 1; d <= days; d++) {
      const dow = new Date(yearVal, monthVal, d).getDay();
      const wknd = dow === 0 || dow === 6;
      const wkndBoost = wknd ? 1.06 : 1.0;
      const noise =
        1 + (((((yearVal * 100 + monthVal) * 31 + d) * 17) % 13) - 6) * 0.007;

      const occ = Math.min(0.98, base.occ * wkndBoost * noise);
      const rooms = Math.round(p.rooms * occ);
      const dayADR = base.adr * wkndBoost;
      const revpar = occ * dayADR;

      const segs = {};
      let allocated = 0;
      const segList = inputs.segments || [];

      let lastNonZeroIdx = -1;
      for (let i = segList.length - 1; i >= 0; i--) {
        if ((inputs.mix[segList[i].key] || 0) > 0) {
          lastNonZeroIdx = i;
          break;
        }
      }
      // We no longer fallback to the last segment if all mixes are 0.
      // This allows all segments to properly read 0 when the mix is 0.

      segList.forEach((seg, i) => {
        const key = seg.key;
        const share = (inputs.mix[key] || 0) / totalMix;
        let r =
          i === lastNonZeroIdx ? rooms - allocated : Math.round(rooms * share);

        if (share === 0 && i !== lastNonZeroIdx) {
          r = 0;
        }

        allocated += r;
        const adr = dayADR;
        segs[key] = {
          rooms: Math.max(0, r),
          adr,
          rev: Math.max(0, r) * adr,
        };
      });
      const rev = segList.reduce((a, seg) => a + segs[seg.key].rev, 0);
      const blendedADR = rooms > 0 ? rev / rooms : 0;

      rows.push({
        day: d,
        dow,
        wknd,
        occ: occ * 100,
        rooms,
        paidRooms: rooms,
        compNight: 0,
        rev,
        adr: blendedADR,
        revPAR: revpar,
        segs,
        totalRev: rev,
      });
    }
    return rows;
  };

  const inputs = useMemo(
    () => ({
      currentProperty,
      occAdj: occAdj / 100,
      paceAdj: paceAdj / 100,
      adrAdj: adrAdj / 100,
      wStly,
      wLy,
      wPace,
      mix,
      segments,
    }),
    [
      currentProperty,
      occAdj,
      paceAdj,
      adrAdj,
      wStly,
      wLy,
      wPace,
      mix,
      segments,
    ],
  );

  const orgAllData = useMemo(() => {
    if (apiOrgData && apiOrgData.length > 0) {
      const list = [];
      for (let m = 0; m < 12; m++) {
        const daysInMonth = new Date(year, m + 1, 0).getDate();
        const monthDays = [];
        for (let d = 1; d <= daysInMonth; d++) {
          const dayDateStr = moment(new Date(year, m, d)).format("YYYY-MM-DD");
          const singleOrgData = apiOrgData.find(
            (x) => moment(x.Date).format("YYYY-MM-DD") === dayDateStr,
          );

          const otb = singleOrgData?.OnTheBook
            ? parseInt(singleOrgData.OnTheBook)
            : 0;
          const rev = singleOrgData?.REV ? parseInt(singleOrgData.REV) : 0;
          const occ = singleOrgData?.TotalOCCPercentage
            ? singleOrgData.TotalOCCPercentage
            : 0;

          monthDays.push({
            day: d,
            otb: otb,
            rev: rev,
            occ: occ,
          });
        }
        list.push(monthDays);
      }
      return list;
    }

    const list = [];
    for (let m = 0; m < 12; m++) {
      const daysInMonth = new Date(year, m + 1, 0).getDate();
      const monthDays = [];
      for (let d = 1; d <= daysInMonth; d++) {
        monthDays.push({ day: d, otb: 0, rev: 0, occ: 0 });
      }
      list.push(monthDays);
    }
    return list;
  }, [year, apiOrgData]);

  const lyAllData = useMemo(() => {
    const sysRooms = currentProperty.rooms;

    if (apiLyData && apiLyData.length > 0) {
      const list = [];
      for (let m = 0; m < 12; m++) {
        const daysInMonth = new Date(year, m + 1, 0).getDate();
        const monthDays = [];
        for (let d = 1; d <= daysInMonth; d++) {
          const dayDateStr = moment(new Date(year, m, d)).format("MM-DD");
          let matchingData = apiLyData.filter(
            (x) => moment(x.Date).format("MM-DD") === dayDateStr,
          );

          // Filter out items that have null or undefined values
          matchingData = matchingData.filter(
            (item) =>
              item.RMS !== null && item.RMS !== undefined && item.RMS !== "",
          );

          let sumRms = 0;
          let sumRev = 0;

          if (matchingData.length > 0) {
            matchingData.forEach((item) => {
              sumRms += item.RMS ? parseInt(item.RMS) : 0;
              sumRev += item.REV ? parseInt(item.REV) : 0;
            });
          }

          const rms =
            matchingData.length > 0
              ? Math.round(sumRms / matchingData.length)
              : 0;
          const rev =
            matchingData.length > 0
              ? Math.round(sumRev / matchingData.length)
              : 0;
          const adr = rms > 0 ? rev / rms : 0;

          const lyDates = matchingData.map(item => item.LY_Date).filter(Boolean);
          monthDays.push({
            day: d,
            paidRooms: rms,
            rooms: rms,
            rev: rev,
            adr: adr,
            totalRev: rev,
            occ: sysRooms > 0 ? (rms / sysRooms) * 100 : 0,
            lyDates: lyDates,
          });
        }
        list.push(monthDays);
      }
      return list;
    }

    const list = [];
    for (let m = 0; m < 12; m++) {
      list.push(generateDayData(year - 1, m, inputs));
    }
    return list;
  }, [year, inputs, apiLyData, currentProperty]);

  const stlyAllData = useMemo(() => {
    const sysRooms = currentProperty.rooms;
    if (apiStlyData && apiStlyData.length > 0) {
      const list = [];
      for (let m = 0; m < 12; m++) {
        const daysInMonth = new Date(year, m + 1, 0).getDate();
        const monthDays = [];
        for (let d = 1; d <= daysInMonth; d++) {
          const dayDateStr = moment(new Date(year, m, d)).format("YYYY-MM-DD");
          const singleStlyData = apiStlyData.find(
            (x) => moment(x.Date).format("YYYY-MM-DD") === dayDateStr,
          );
          const rms = singleStlyData?.STLY_RMS
            ? parseInt(singleStlyData.STLY_RMS)
            : 0;
          const rev = singleStlyData?.STLY_REV
            ? parseInt(singleStlyData.STLY_REV)
            : 0;
          const adr = singleStlyData?.STLY_ADR
            ? parseFloat(singleStlyData.STLY_ADR)
            : rms > 0
              ? rev / rms
              : 0;

          monthDays.push({
            day: d,
            paidRooms: rms,
            rooms: rms,
            rev: rev,
            adr: adr,
            totalRev: rev,
            occ: sysRooms > 0 ? (rms / sysRooms) * 100 : 0,
          });
        }
        list.push(monthDays);
      }
      return list;
    }

    const list = [];
    for (let m = 0; m < 12; m++) {
      list.push(generateDayData(year - 1, m, inputs));
    }
    return list;
  }, [year, inputs, apiStlyData, currentProperty]);

  const lyForecastAllData = useMemo(() => {
    const sysRooms = currentProperty.rooms;
    if (apiLyForecastData && apiLyForecastData.length > 0) {
      const list = [];
      for (let m = 0; m < 12; m++) {
        const daysInMonth = new Date(year, m + 1, 0).getDate();
        const monthDays = [];
        for (let d = 1; d <= daysInMonth; d++) {
          const dayDateStr = moment(new Date(year, m, d)).format("YYYY-MM-DD");
          const singleForecast = apiLyForecastData.find(
            (x) => moment(x.Dates).format("YYYY-MM-DD") === dayDateStr,
          );

          const rms = singleForecast?.RMS ? parseInt(singleForecast.RMS) : 0;
          const rev = singleForecast?.REV ? parseInt(singleForecast.REV) : 0;
          const adr = singleForecast?.ADR
            ? parseFloat(singleForecast.ADR)
            : rms > 0
              ? rev / rms
              : 0;
          const occ = sysRooms > 0 ? (rms / sysRooms) * 100 : 0;

          monthDays.push({
            day: d,
            rooms: rms,
            rev: rev,
            adr: adr,
            occ: occ,
          });
        }
        list.push(monthDays);
      }
      return list;
    }

    const list = [];
    for (let m = 0; m < 12; m++) {
      const daysInMonth = new Date(year, m + 1, 0).getDate();
      const monthDays = [];
      for (let d = 1; d <= daysInMonth; d++) {
        monthDays.push({ day: d, rooms: 0, rev: 0, adr: 0, occ: 0 });
      }
      list.push(monthDays);
    }
    return list;
  }, [year, apiLyForecastData, currentProperty]);

  const allData = useMemo(() => {
    const list = [];
    const capacity = inputs.currentProperty?.rooms || 1;

    for (let m = 0; m < 12; m++) {
      const daysInMonth = new Date(year, m + 1, 0).getDate();
      const monthDays = [];

      for (let d = 1; d <= daysInMonth; d++) {
        const dayIdx = d - 1;

        const sysData =
          lyForecastAllData && lyForecastAllData[m]
            ? lyForecastAllData[m][dayIdx]
            : null;
        const otbData =
          orgAllData && orgAllData[m] ? orgAllData[m][dayIdx] : null;
        const stlyData =
          stlyAllData && stlyAllData[m] ? stlyAllData[m][dayIdx] : null;
        const lyData = lyAllData && lyAllData[m] ? lyAllData[m][dayIdx] : null;

        const normOcc = (val) => {
          let occ = val || 0;
          if (occ > 1.5) occ = occ / 100;
          return occ;
        };

        const sysOcc = sysData ? normOcc(sysData.occ) : 0;
        const otbRooms = otbData && otbData.otb ? otbData.otb : 0;
        const otbOcc = capacity > 0 ? otbRooms / capacity : 0;
        const stlyOcc = stlyData ? normOcc(stlyData.occ) : 0;
        const lyOcc = lyData ? normOcc(lyData.occ) : 0;

        const sysADR = sysData && sysData.adr ? sysData.adr : 0;

        const wSys = Math.max(
          0,
          100 - inputs.wPace - inputs.wStly - inputs.wLy,
        );
        const totalWeight =
          wSys + inputs.wPace + inputs.wStly + inputs.wLy || 100;

        let fcstOcc =
          (sysOcc * wSys +
            otbOcc * inputs.wPace +
            stlyOcc * inputs.wStly +
            lyOcc * inputs.wLy) /
          totalWeight;
        fcstOcc = fcstOcc * (1 + inputs.occAdj);

        fcstOcc = Math.min(0.98, fcstOcc);

        const fcstADR = sysADR * (1 + inputs.adrAdj);

        let fcstRevPAR = fcstOcc * fcstADR;
        let fcstRooms = Math.round(fcstOcc * capacity);

        const segs = {};
        let allocated = 0;
        const segList = inputs.segments || [];
        const totalMix =
          Object.values(inputs.mix).reduce((a, b) => a + b, 0) || 1;

        let lastNonZeroIdx = -1;
        for (let i = segList.length - 1; i >= 0; i--) {
          if ((inputs.mix[segList[i].key] || 0) > 0) {
            lastNonZeroIdx = i;
            break;
          }
        }
        // We no longer fallback to the last segment if all mixes are 0.

        segList.forEach((seg, i) => {
          const key = seg.key;
          const share = (inputs.mix[key] || 0) / totalMix;
          let r =
            i === lastNonZeroIdx
              ? fcstRooms - allocated
              : Math.round(fcstRooms * share);

          if (share === 0 && i !== lastNonZeroIdx) {
            r = 0;
          }

          allocated += r;
          const adr = fcstADR;

          let segRooms = Math.max(0, r);
          let segAdr = adr;
          let segRev = Math.max(0, r) * adr;

          // Apply overrides
          if (
            segmentOverrides[m] &&
            segmentOverrides[m][d] &&
            segmentOverrides[m][d][key]
          ) {
            const override = segmentOverrides[m][d][key];
            if (override.rooms !== undefined) segRooms = override.rooms;
            if (override.adr !== undefined) segAdr = override.adr;
            if (override.rev !== undefined) segRev = override.rev;
          }

          segs[key] = {
            rooms: segRooms,
            adr: segAdr,
            rev: segRev,
          };
        });

        // Recalculate daily totals based on potentially overridden segments
        const finalRev = segList.reduce(
          (a, seg) => a + (Number(segs[seg.key]?.rev) || 0),
          0,
        );
        const finalRooms = segList.reduce(
          (a, seg) => a + (Number(segs[seg.key]?.rooms) || 0),
          0,
        );
        const blendedADR = finalRooms > 0 ? finalRev / finalRooms : 0;

        fcstRooms = finalRooms;
        fcstOcc = capacity > 0 ? fcstRooms / capacity : 0;
        fcstRevPAR = fcstOcc * blendedADR;

        const dow = new Date(year, m, d).getDay();
        const wknd = dow === 0 || dow === 6;

        let dayData = {
          day: d,
          dow,
          wknd,
          occ: fcstOcc * 100,
          rooms: fcstRooms,
          paidRooms: fcstRooms,
          compNight: 0,
          rev: finalRev,
          adr: blendedADR,
          revPAR: fcstRevPAR,
          segs,
          totalRev: finalRev,
        };

        if (dayOverrides[m] && dayOverrides[m][d]) {
          const ov = dayOverrides[m][d];

          if (ov.paidRooms !== undefined) {
            dayData.paidRooms = ov.paidRooms;
            dayData.rooms = ov.paidRooms + dayData.compNight;
            dayData.occ = capacity > 0 ? (dayData.rooms / capacity) * 100 : 0;
          }
          if (ov.occ !== undefined) {
            dayData.occ = ov.occ;
            dayData.rooms = Math.round((ov.occ / 100) * capacity);
            dayData.paidRooms = Math.max(0, dayData.rooms - dayData.compNight);
          }
          if (ov.rev !== undefined) {
            dayData.rev = ov.rev;
            dayData.totalRev = ov.rev;
          }
          if (ov.adr !== undefined) {
            dayData.adr = ov.adr;
          }

          if (ov.paidRooms !== undefined && ov.adr === undefined) {
            dayData.rev = dayData.paidRooms * dayData.adr;
            dayData.totalRev = dayData.rev;
          } else if (ov.adr !== undefined && ov.paidRooms === undefined) {
            dayData.rev = dayData.paidRooms * dayData.adr;
            dayData.totalRev = dayData.rev;
          } else if (
            ov.rev !== undefined &&
            ov.paidRooms === undefined &&
            ov.adr === undefined
          ) {
            dayData.adr =
              dayData.paidRooms > 0 ? dayData.rev / dayData.paidRooms : 0;
          }

          dayData.revPAR = (dayData.occ * dayData.adr) / 100;
        }

        monthDays.push(dayData);
      }
      list.push(monthDays);
    }
    return list;
  }, [
    year,
    inputs,
    orgAllData,
    lyAllData,
    stlyAllData,
    lyForecastAllData,
    segmentOverrides,
    dayOverrides,
  ]);

  const sortedSegments = useMemo(() => {
    return [...segments].sort((a, b) => {
      let revA = 0;
      let revB = 0;
      allData.forEach((monthRows) => {
        monthRows.forEach((r) => {
          revA += r.segs?.[a.key]?.rev || 0;
          revB += r.segs?.[b.key]?.rev || 0;
        });
      });
      return revB - revA;
    });
  }, [segments, allData]);

  const activeMonthRows = allData[activeMonth];
  const activeOrgMonthRows = orgAllData[activeMonth];
  const activeLYMonthRows = lyAllData[activeMonth];
  const activeSTLYMonthRows = stlyAllData[activeMonth];
  const activeLYForecastMonthRows = lyForecastAllData[activeMonth];

  // Aggregated calculations for active month
  const sumActive = (key) =>
    activeMonthRows.reduce((a, r) => a + (r[key] || 0), 0);
  const activeMonthAvail = activeMonthRows.length * currentProperty.rooms;
  const activeMonthRooms = sumActive("rooms");
  const activeMonthPaidRooms = sumActive("paidRooms");
  const activeMonthOcc = (activeMonthRooms / activeMonthAvail) * 100;
  const activeMonthGrossRev = sumActive("rev");
  const activeMonthADR =
    activeMonthPaidRooms > 0 ? activeMonthGrossRev / activeMonthPaidRooms : 0;
  const activeMonthRevPAR = activeMonthGrossRev / activeMonthAvail;
  const activeMonthTRevPAR = sumActive("totalRev") / activeMonthAvail;

  const activeMonthOtaCommAmt = sumActive("otaCommAmt");
  const activeMonthGdsFee = sumActive("gdsFee");
  const activeMonthFranchiseFee = sumActive("franchiseFee");
  const activeMonthLoyaltyFee = sumActive("loyaltyFee");
  const activeMonthNetRoomRev = sumActive("netRoomRev");

  const activeMonthFnbRev = sumActive("fnbRev");
  const activeMonthMtgRev = sumActive("mtgRev");
  const activeMonthOtherRevAmt = sumActive("otherRevAmt");
  const activeMonthTotalAncillary = sumActive("totalAncillary");
  const activeMonthTotalRev = sumActive("totalRev");
  const activeMonthTaxAmt = sumActive("taxAmt");

  const activeMonthGrpPickup = sumActive("grpPickup");
  const activeMonthGrpBlocked = sumActive("grpBlocked");

  // YTD Calculations
  const ytdMonths = allData.slice(0, activeMonth + 1);
  const ytdFlat = ytdMonths.flat();
  const ytdPaid = ytdFlat.reduce((a, r) => a + r.paidRooms, 0);
  const ytdGross = ytdFlat.reduce((a, r) => a + r.rev, 0);
  const ytdNet = ytdFlat.reduce((a, r) => a + r.totalRev, 0);
  const ytdAvail = ytdFlat.length * currentProperty.rooms;

  // Annual Totals (Dynamicized based on flattened engine calendar to secure absolute precision)
  const annualAvail = allData.flat().length * currentProperty.rooms;
  const annualPaidRooms = allData.flat().reduce((a, r) => a + r.paidRooms, 0);
  const annualOccRooms = allData.flat().reduce((a, r) => a + r.rooms, 0);
  const annualRoomRev = allData.flat().reduce((a, r) => a + r.rev, 0);
  const annualNetRev = allData.flat().reduce((a, r) => a + r.totalRev, 0);
  const annualOcc = (annualOccRooms / annualAvail) * 100;
  const annualADR = annualPaidRooms > 0 ? annualRoomRev / annualPaidRooms : 0;
  const annualRevPAR = annualRoomRev / annualAvail;
  const annualTRevPAR = annualNetRev / annualAvail;

  // Annual LY Totals
  const annualLYPaidRooms = lyAllData
    .flat()
    .reduce((a, r) => a + r.paidRooms, 0);
  const annualLYOccRooms = lyAllData.flat().reduce((a, r) => a + r.rooms, 0);
  const annualLYRoomRev = lyAllData.flat().reduce((a, r) => a + r.rev, 0);
  const annualLYNetRev = lyAllData.flat().reduce((a, r) => a + r.totalRev, 0);
  const annualLYOcc = (annualLYOccRooms / annualAvail) * 100;
  const annualLYADR =
    annualLYPaidRooms > 0 ? annualLYRoomRev / annualLYPaidRooms : 0;
  const annualLYRevPAR = annualLYRoomRev / annualAvail;
  const annualLYTRevPAR = annualLYNetRev / annualAvail;

  // Annual STLY Totals
  const annualSTLYRoomRev = stlyAllData.flat().reduce((a, r) => a + r.rev, 0);
  const annualSTLYRevPAR = annualSTLYRoomRev / annualAvail;

  const varPct = (bgt, ly) => {
    if (!ly) return 0;
    return ((bgt - ly) / ly) * 100;
  };

  const getLYDay = (monthIdx, day) => {
    return lyAllData[monthIdx] && lyAllData[monthIdx][day - 1];
  };

  const getSTLYDay = (monthIdx, day) => {
    return stlyAllData[monthIdx] && stlyAllData[monthIdx][day - 1];
  };

  const getLyForecastDay = (monthIdx, day) => {
    return lyForecastAllData[monthIdx] && lyForecastAllData[monthIdx][day - 1];
  };

  // Month navigation calculation summaries
  const monthNavSummary = useMemo(() => {
    return allData.map((rows, i) => {
      const occSum = rows.reduce((a, r) => a + r.occ, 0) / rows.length;
      // const roomsSum = rows.reduce((a, r) => a + r.rooms, 0);
      const roomsSum = rows.reduce((a, r) => a + r.paidRooms, 0);
      return {
        idx: i,
        name: MONTHS_SHORT[i],
        occ: occSum,
        rooms: roomsSum,
      };
    });
  }, [allData]);

  // Segment Card summary calculations
  const segmentCardData = useMemo(() => {
    const totals = {};
    segments.forEach((s) => {
      totals[s.key] = { rooms: 0, rev: 0 };
    });
    activeMonthRows.forEach((r) => {
      segments.forEach((s) => {
        if (r.segs[s.key]) {
          totals[s.key].rooms += r.segs[s.key].rooms;
          totals[s.key].rev += r.segs[s.key].rev;
        }
      });
    });
    return sortedSegments.map((s) => {
      const adr =
        totals[s.key].rooms > 0 ? totals[s.key].rev / totals[s.key].rooms : 0;
      return {
        ...s,
        rooms: totals[s.key].rooms,
        rev: totals[s.key].rev,
        adr,
      };
    });
  }, [activeMonthRows, sortedSegments]);

  // Chart data
  const chart1Data = useMemo(
    () => ({
      labels: activeMonthRows.map((r) => r.day),
      datasets: sortedSegments.map((s) => ({
        label: s.label,
        data: activeMonthRows.map((r) => r.segs[s.key]?.rooms || 0),
        backgroundColor: s.color,
        stack: "rooms",
        maxBarThickness: 40,
        hidden: !!hiddenSegments[s.key],
      })),
    }),
    [activeMonthRows, sortedSegments, hiddenSegments],
  );

  // Clean up tooltip element on unmount
  useEffect(() => {
    if (api === 0) return;
    return () => {
      const el = document.getElementById("chartjs-tooltip");
      if (el) {
        el.remove();
      }
    };
  }, []);

  // Custom HTML Tooltip Handler to support scrollbars
  const externalTooltipHandler = (context) => {
    let tooltipEl = document.getElementById("chartjs-tooltip");

    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.id = "chartjs-tooltip";
      tooltipEl.style.background = "#222222";
      tooltipEl.style.borderRadius = "6px";
      tooltipEl.style.color = "#FFFFFF";
      tooltipEl.style.opacity = 0;
      tooltipEl.style.position = "absolute";
      tooltipEl.style.pointerEvents = "auto";
      tooltipEl.style.transition = "opacity 0.15s ease, transform 0.1s ease";
      tooltipEl.style.fontSize = "12px";
      tooltipEl.style.fontFamily = "Inter, sans-serif";
      tooltipEl.style.padding = "10px 12px";
      tooltipEl.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.3)";
      tooltipEl.style.border = "1px solid rgba(255, 255, 255, 0.1)";
      tooltipEl.style.zIndex = "10000";

      tooltipEl.onmouseenter = () => {
        tooltipEl.style.opacity = "1";
      };
      tooltipEl.onmouseleave = () => {
        tooltipEl.style.opacity = "0";
      };

      document.body.appendChild(tooltipEl);
    }

    const tooltipModel = context.tooltip;

    if (tooltipModel.opacity === 0) {
      if (!tooltipEl.matches(":hover")) {
        tooltipEl.style.opacity = 0;
      }
      return;
    }

    if (tooltipModel.body) {
      const titleLines = tooltipModel.title || [];
      const bodyLines = tooltipModel.body.map((bodyItem) => bodyItem.lines);

      let innerHtml = "";

      titleLines.forEach((title) => {
        innerHtml += `<div style="font-weight: 700; font-size: 14px; margin-bottom: 6px;">${title}</div>`;
      });

      innerHtml += `<div class="chartjs-tooltip-scroll" style="max-height: 150px; overflow-y: auto; display: flex; flex-direction: column; gap: 4px; padding-right: 4px;">`;

      bodyLines.forEach((body, i) => {
        const colors = tooltipModel.labelColors[i];
        const colorSpan = `<span style="display: inline-block; width: 10px; height: 10px; border: 1px solid #fff; background: ${colors.backgroundColor}; margin-right: 6px; flex-shrink: 0;"></span>`;
        const lineText = body[0] || "";
        const parts = lineText.split(":");
        const label = parts[0] ? parts[0].trim() : "";
        const val = parts[1] ? parts[1].trim() : "";

        innerHtml += `<div style="display: flex; align-items: center; font-size: 12px;">
          ${colorSpan}
          <span style="text-transform: capitalize; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${label}: ${val}</span>
        </div>`;
      });

      innerHtml += `</div>`;

      tooltipEl.innerHTML = innerHtml;
    }

    const position = context.chart.canvas.getBoundingClientRect();

    tooltipEl.style.opacity = 1;
    let leftPos = position.left + window.pageXOffset + tooltipModel.caretX + 12;
    let topPos = position.top + window.pageYOffset + tooltipModel.caretY - 60;

    const tooltipWidth = 240;
    if (leftPos + tooltipWidth > window.innerWidth) {
      leftPos =
        position.left +
        window.pageXOffset +
        tooltipModel.caretX -
        tooltipWidth -
        12;
    }

    tooltipEl.style.left = leftPos + "px";
    tooltipEl.style.top = topPos + "px";
  };

  const chart1Options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        mode: "index",
        intersect: false,
        itemSort: (a, b) => b.raw - a.raw,
        external: externalTooltipHandler,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 16,
          font: { size: 10 },
        },
        grid: { display: false },
      },
      y: {
        stacked: true,
        ticks: { font: { size: 10 } },
        grid: { color: "rgba(0,0,0,0.05)" },
      },
    },
  };

  const chart2Data = useMemo(
    () => ({
      labels: activeMonthRows.map((r) => r.day),
      datasets: sortedSegments.map((s) => ({
        label: s.label,
        data: activeMonthRows.map(
          (r) => +((r.segs[s.key]?.rev || 0) / 1000).toFixed(1),
        ),
        backgroundColor: s.color,
        stack: "rev",
        barThickness: 6,
        hidden: !!hiddenSegments2[s.key],
      })),
    }),
    [activeMonthRows, sortedSegments, hiddenSegments2],
  );

  // 1. Put this with your hooks at the top of the BudgetSimulator component
  const yearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear - 2; y <= currentYear + 5; y++) {
      years.push(y);
    }
    return years;
  }, []);

  const chart2Options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        mode: "index",
        intersect: false,
        itemSort: (a, b) => b.raw - a.raw,
        external: externalTooltipHandler,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          maxRotation: 0,
          autoSkip: true,
          maxTicksLimit: 16,
          font: { size: 10 },
        },
        grid: { display: false },
      },
      y: {
        stacked: true,
        ticks: { font: { size: 10 }, callback: (v) => `$${v}K` },
        grid: { color: "rgba(0,0,0,0.05)" },
      },
    },
  };

  const handleApplyLY = async () => {
    if (selectedYears.length > 0) {
      setApiLyLoading(true);
      await fetchLyData(selectedYears, isDatewise);
      setShowLY(true);
    } else {
      setShowLY(false);
    }
    document.body.click(); // Close popover
  };

  const handleDatewiseApplyLY = async (isChecked) => {
    setIsDatewise(isChecked);
    setIsLYDatewiseLoading(true);
    await fetchLyData(selectedYears, isChecked);
    setIsLYDatewiseLoading(false);
  };

  const handleDatewiseApplySTLY = async (isChecked) => {
    if (api === 0) return;
    setIsDatewiseSTLY(isChecked);
    setIsSTLYDatewiseLoading(true);
    await fetchStlyData(null, isChecked);
    setIsSTLYDatewiseLoading(false);
  };

  const handleToggleSTLY = async () => {
    if (api === 0) return;
    if (!showSTLY) {
      await fetchStlyData(null, isDatewiseSTLY);
      setShowSTLY(true);
    } else {
      setShowSTLY(false);
    }
  };

  const compareYearOptions = useMemo(() => {
    const options = [];
    for (let i = 1; i <= 8; i++) {
      const prevYear = year - i;
      options.push({ value: prevYear, label: prevYear.toString() });
    }
    return options;
  }, [year]);

  const lyPopover = (
    <Popover id="ly-compare-popover" style={{ minWidth: "380px" }}>
      <Popover.Header as="h6">Compare with Previous Years</Popover.Header>

      <Popover.Body>
        <div className="mb-3">
          <label className="form-label fw-semibold">Select Year(s)</label>

          <Select
            isMulti
            closeMenuOnSelect={false}
            options={compareYearOptions}
            value={selectedYears}
            onChange={(value) => setSelectedYears(value || [])}
            placeholder="Choose year(s)"
            styles={{
              menu: (provided) => ({ ...provided, zIndex: 1000, width: "40%" }),
            }}
          />
        </div>

        <div className="d-flex justify-content-end gap-2">
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => {
              setSelectedYears([]);
              setShowLY(false);
            }}
          >
            Clear
          </Button>

          <Button size="sm" variant="primary" onClick={handleApplyLY}>
            Apply
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      {propertyCode ? (
    <div
      className="widget-container bs-style-1"
      style={{ position: "relative", padding: "0 5px" }}
    >
      <div className="d-flex justify-content-between align-items-baseline">
        <header className="groupwash-header mb-0">
          <h6>User Forecast Simulator</h6>
        </header>
      </div>

      <div className="budget-simulator-container">
        {/* {apiLyLoading && <Loader />} */}

        {/* CONTROLS BAR */}
        <div className="controls">
          <div className="ctrl-group">
            <span className="ctrl-label">Forecast Year</span>
            <select
              value={year}
              onChange={(e) => setYear(parseInt(e.target.value))}
            >
              {yearOptions.map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
          </div>
          <div className="ctrl-group">
            <span className="ctrl-label">View Mode</span>
            <select
              value={viewMode}
              onChange={(e) => setViewMode(e.target.value)}
            >
              <option value="rooms">Rooms + Revenue</option>
              <option value="rooms_only">Rooms Only</option>
              <option value="revenue_only">Revenue Only</option>
              <option value="adr">ADR Focus</option>
            </select>
          </div>
          <div className="ctrl-group">
            <span className="ctrl-label">Segment</span>
            <Select
              value={
                segOptions.filter((opt) => opt.value === segFilter) || null
              }
              options={segOptions}
              onChange={(opt) => setSegFilter(opt ? opt.value : "all")}
              isSearchable={false}
              isClearable={false}
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "32px",
                  height: "32px",
                  width: "200px",
                  fontSize: "13px",
                  borderRadius: "6px",
                  borderColor: "#cfd9f8",
                  backgroundColor: "#FFFFFF",
                  boxShadow: "none",
                  "&:hover": {
                    borderColor: "#3565FC",
                  },
                }),
                valueContainer: (provided) => ({
                  ...provided,
                  height: "32px",
                  padding: "0 8px",
                  display: "flex",
                  alignItems: "center",
                }),
                singleValue: (provided) => ({
                  ...provided,
                  color: "#202842",
                  margin: "0",
                }),
                input: (provided) => ({
                  ...provided,
                  margin: "0",
                  padding: "0",
                }),
                indicatorsContainer: (provided) => ({
                  ...provided,
                  height: "32px",
                }),
                dropdownIndicator: (provided) => ({
                  ...provided,
                  padding: "4px",
                }),
                indicatorSeparator: () => ({
                  display: "none",
                }),
                menu: (provided) => ({
                  ...provided,
                  fontSize: "13px",
                  zIndex: 10,
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected
                    ? "rgba(53, 101, 252, 0.15)"
                    : state.isFocused
                      ? "rgba(53, 101, 252, 0.05)"
                      : "transparent",
                  color: state.isSelected ? "#3565FC" : "#202842",
                  cursor: "pointer",
                  padding: "8px 12px",
                  "&:active": {
                    backgroundColor: "rgba(53, 101, 252, 0.15)",
                  },
                }),
              }}
            />
          </div>

          <div className="spacer"></div>
          <Button
            className={`default-btn ${showSTLY ? "btn-ly-active" : "primary-btn"} cursor-pointer`}
            onClick={handleToggleSTLY}
            title="Show Same Time Last Year actuals alongside budget for comparison"
          >
            STLY Compare
          </Button>
          <OverlayTrigger
            trigger="click"
            rootClose
            placement="bottom"
            overlay={lyPopover}
          >
            <Button
              className={`default-btn ${
                showLY ? "btn-ly-active" : "primary-btn"
              } cursor-pointer`}
              title="Show Last Year actuals alongside budget for comparison"
            >
              LY Compare
            </Button>
          </OverlayTrigger>
          <Button
            onClick={resetDrivers}
            className="default-btn primary-btn cursor-pointer ms-0"
          >
            Recalculate
          </Button>
          {saveLoading ? (
            <Button
              className="default-btn primary-btn ms-0 us-style-2"
              type="button"
              disabled
            >
              Saving...
            </Button>
          ) : (
            <Button
              className="default-btn primary-btn cursor-pointer ms-0"
              id={commonService.generateGlobalClickTrackerID(
                "UserSimulator",
                "save",
                "",
              )}
              disabled={
                segFilter !== "all" || viewMode !== "rooms" || saveLoading
              }
              onClick={() => {
                handleSave();
              }}
              style={{ marginLeft: "10px" }}
            >
              Save
            </Button>
          )}
        </div>
        {apiLyLoading ? (
          <Loader />
        ) : (
          <>
            {/* KPI ROW */}
            <div className="kpi-row us-style-3">
              {[
                {
                  label: "Forecast RevPAR",
                  val: fmtDollar(annualRevPAR, 2),
                  var: varPct(annualRevPAR, annualSTLYRevPAR),
                  showVar: true,
                  subtext: "vs STLY",
                },
                {
                  label: "Forecast Occ",
                  val: fmtPct(annualOcc),
                  var: varPct(annualRevPAR, annualLYRevPAR),
                  showVar: true,
                  subtext: "RevPAR vs LY",
                },
                {
                  label: "Blended ADR",
                  val: fmtDollar(annualADR, 2),
                  showVar: false,
                },
                {
                  label: "Room Revenue",
                  val: fmtDollar(annualRoomRev / 1000, 0) + "K",
                  showVar: true,
                  customStaticText: `FY ${year} forecast`,
                },
                {
                  label: "STLY RevPAR",
                  val: fmtDollar(annualSTLYRevPAR, 2),
                  showVar: true,
                  customStaticText: "same time last yr",
                },
                {
                  label: "LY RevPAR",
                  val: fmtDollar(annualLYRevPAR, 2),
                  showVar: true,
                  customStaticText: "last year actual",
                },
              ].map((kpi, idx) => (
                <div key={idx} className="kpi-card">
                  <div className="kpi-label">{kpi.label}</div>
                  <div className="kpi-val-row">
                    <span className="kpi-val">{kpi.val}</span>
                  </div>
                  {kpi.showVar ? (
                    <div className="kpi-change">
                      {kpi.customStaticText ? (
                        <span className="kpi-change-text">
                          {kpi.customStaticText}
                        </span>
                      ) : (
                        <>
                          <span
                            className={`kpi-badge ${kpi.var > 0 ? "kpi-badge-green" : kpi.var < 0 ? "kpi-badge-red" : "kpi-badge-flat"}`}
                          >
                            {kpi.var > 0 ? "↑" : kpi.var < 0 ? "↓" : "•"}
                          </span>
                          <span className="kpi-change-text">
                            {kpi.var > 0
                              ? `+${kpi.var.toFixed(1)}`
                              : kpi.var.toFixed(1)}
                            % {kpi.subtext}
                          </span>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className="kpi-change-empty">&nbsp;</div>
                  )}
                </div>
              ))}
            </div>

            {/* MONTH TABS AND SEASONALITY */}
            <div className="content pt-0 px-3 pb-1">
              {/* <div className="d-flex justify-content-between align-items-center mb-1">
            <Button onClick={resetSeasonality} className="default-btn primary-btn cursor-pointer ms-0">
              ↺ Reset Seasonality
            </Button>
          </div> */}
              <div className="month-tabs-container us-style-4">
                {monthNavSummary.map((m) => {
                  const isActive = m.idx === activeMonth;
                  return (
                    <div
                      key={m.idx}
                      className="shadow-sm month-card-wrapper"
                      onClick={() => setActiveMonth(m.idx)}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        minWidth: "110px",
                        flex: "0 0 auto",
                        backgroundColor: isActive ? "#FFFFFF" : "#F8FAFC",
                        border: isActive
                          ? "2px solid #3B82F6"
                          : "1px solid #E2E8F0",
                        borderRadius: "8px",
                        padding: "8px 10px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        boxShadow: isActive
                          ? "0 4px 6px -1px rgba(59, 130, 246, 0.1), 0 2px 4px -1px rgba(59, 130, 246, 0.06)"
                          : "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
                      }}
                    >
                      {/* TOP: Month Info */}
                      <div className="us-style-5">
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "14px",
                            color: isActive ? "#3B82F6" : "#475569",
                          }}
                        >
                          {m.name}
                        </div>
                        <div
                          style={{
                            fontSize: "10px",
                            fontWeight: "600",
                            color: isActive ? "#64748B" : "#94A3B8",
                          }}
                        >
                          {fmtNum(m.rooms)} rms
                        </div>
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          color: isActive ? "#2563EB" : "#64748B",
                          marginBottom: "8px",
                          fontWeight: "600",
                        }}
                      >
                        {fmtPct(m.occ)} occ
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* TOP LEVEL TABS */}
            <div className="d-flex mb-0 border-bottom px-3 us-style-6">
              <button
                className="btn btn-link text-decoration-none"
                onClick={() => setActiveMainTab("breakdown")}
                style={{
                  // padding: "12px 16px",
                  borderRadius: 0,
                  borderBottom:
                    activeMainTab === "breakdown"
                      ? "3px solid #3B82F6"
                      : "3px solid transparent",
                  color: activeMainTab === "breakdown" ? "#1E293B" : "#64748B",
                  fontWeight: activeMainTab === "breakdown" ? "600" : "500",
                  fontSize: "15px",
                  transition: "all 0.2s",
                }}
              >
                Detailed Budget Breakdown
              </button>
              <button
                className="btn btn-link text-decoration-none"
                onClick={() => setActiveMainTab("summary")}
                style={{
                  // padding: "12px 16px",
                  borderRadius: 0,
                  borderBottom:
                    activeMainTab === "summary"
                      ? "3px solid #3B82F6"
                      : "3px solid transparent",
                  color: activeMainTab === "summary" ? "#1E293B" : "#64748B",
                  fontWeight: activeMainTab === "summary" ? "600" : "500",
                  fontSize: "15px",
                  transition: "all 0.2s",
                }}
              >
                Segment Forecast & Charts
              </button>
            </div>

            {activeMainTab === "breakdown" && (
              <div className="tab-pane-breakdown w-100">
                {/* MAIN LAYOUT */}
                <div className="main-body">
                  {/* CONTENT AREA */}
                  <div className="content">
                    <div className="">
                      {/* DAY-BY-DAY TABLE */}
                      <div className="ViewPropertySetupTable">
                        <div className="stripped__table">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th
                                  rowSpan={2}
                                  colSpan={3}
                                  className="th-left-pad border_right text-center"
                                >
                                  DATE
                                </th>
                                {/* <th
                                  rowSpan={2}
                                  className="th-left-pad border_right text-center"
                                >
                                  EVENTS
                                </th> */}
                                {/* <th
                                  rowSpan={2}
                                  className="th-left-pad border_right text-center"
                                >
                                  DAY
                                </th> */}
                                {/* On The Book Group */}
                                <th
                                  colSpan={3}
                                  className="text-center border_right"
                                >
                                  On The Book
                                </th>
                                {/* User Forecast Group */}
                                <th
                                  colSpan={viewMode !== "rooms_only" ? 4 : 2}
                                  className="text-center border_right"
                                >
                                  User Forecast
                                </th>
                                {/* System Forecast Group */}
                                <th
                                  colSpan={4}
                                  className="text-center border_right"
                                >
                                  System Forecast
                                </th>
                                {/* STLY Group */}
                                {showSTLY && (
                                  <>
                                    <th
                                      colSpan={3}
                                      className="stly-group-head text-center border_right"
                                    >
                                      <div className="d-flex align-items-center justify-content-center gap-2">
                                        <span>STLY</span>

                                        <div
                                          className="form-check form-switch no-border-break from-groups jay-put-this-checkbox mb-0"
                                          style={{
                                            minHeight: "auto",
                                            paddingTop: "2px",
                                          }}
                                        >
                                          <span className="pe-1">DATE</span>
                                          {isSTLYDatewiseLoading ? (
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          ) : (
                                            <input
                                              id={commonService.generateGlobalClickTrackerID(
                                                "UserSimulator",
                                                "STLY-switch-btn",
                                                "",
                                              )}
                                              className="form-check-input m-0 cursor-pointer"
                                              type="checkbox"
                                              role="switch"
                                              checked={isDatewiseSTLY}
                                              onChange={(e) => {
                                                handleDatewiseApplySTLY(
                                                  e?.target.checked ?? false,
                                                );
                                              }}
                                            />
                                          )}
                                          <span className="ps-1">DOW</span>
                                        </div>
                                      </div>
                                    </th>
                                    <th
                                      colSpan={3}
                                      className="stly-group-head-var text-center border_right"
                                    >
                                      STLY Vs OTB
                                    </th>
                                  </>
                                )}
                                {/* Total LY Group */}
                                {showLY && (
                                  <>
                                    <th
                                      colSpan={4}
                                      className="ly-group-head text-center border_right"
                                    >
                                      <div className="d-flex align-items-center justify-content-center gap-2">
                                        <div className="width45">Total LY</div>

                                        <div
                                          className="form-check form-switch no-border-break from-groups jay-put-this-checkbox mb-0"
                                          style={{
                                            minHeight: "auto",
                                            paddingTop: "2px",
                                          }}
                                        >
                                          <span className="pe-1">DATE</span>
                                          {isLYDatewiseLoading ? (
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                          ) : (
                                            <input
                                              id={commonService.generateGlobalClickTrackerID(
                                                "UserSimulator",
                                                "ly-switch-btn",
                                                "",
                                              )}
                                              className="form-check-input m-0 cursor-pointer"
                                              type="checkbox"
                                              role="switch"
                                              checked={isDatewise}
                                              onChange={(e) => {
                                                handleDatewiseApplyLY(
                                                  e?.target.checked ?? false,
                                                );
                                              }}
                                            />
                                          )}
                                          <span className="ps-1">DOW</span>
                                        </div>
                                      </div>
                                    </th>
                                    <th
                                      colSpan={3}
                                      className="ly-group-head-var text-center border_right"
                                    >
                                      Total LY vs OTB
                                    </th>
                                  </>
                                )}
                                {segFilter === "all" ? (
                                  <>
                                    {sortedSegments.map((s) => {
                                      let colSpan = 2;
                                      if (viewMode === "adr") colSpan = 3;
                                      else if (
                                        viewMode === "rooms_only" ||
                                        viewMode === "revenue_only"
                                      )
                                        colSpan = 1;
                                      return (
                                        <th
                                          key={s.key}
                                          colSpan={colSpan}
                                          className="seg-group-header text-center border_right"
                                        >
                                          {s.label.toUpperCase()}
                                        </th>
                                      );
                                    })}
                                  </>
                                ) : (
                                  <>
                                    {(() => {
                                      const s =
                                        segments.find(
                                          (x) => x.key === segFilter,
                                        ) || segments[0];
                                      return (
                                        <th
                                          colSpan={3}
                                          className="seg-group-header text-center border_right"
                                        >
                                          {s?.label.toUpperCase()}
                                        </th>
                                      );
                                    })()}
                                  </>
                                )}
                              </tr>
                              <tr>
                                {/* On The Book Sub-columns */}
                                <th className="text-center">
                                  ON THE
                                  <br />
                                  BOOK
                                </th>
                                <th className="text-right">REV</th>
                                <th className="text-center border_right">
                                  TOTAL
                                  <br />
                                  OCC%
                                </th>

                                {/* User Forecast Sub-columns */}
                                <th className="text-center">
                                  TOTAL ROOM
                                  <br />
                                  SOLD
                                </th>
                                <th
                                  className={`text-center ${viewMode === "rooms_only" ? "border_right" : ""}`}
                                >
                                  OCC%
                                </th>
                                {viewMode !== "rooms_only" && (
                                  <>
                                    <th className="text-center">
                                      TOTAL
                                      <br />
                                      REVENUE
                                    </th>
                                    <th className="text-center border_right">
                                      ADR
                                    </th>
                                  </>
                                )}

                                {/* System Forecast Sub-columns */}
                                <th className="text-center">
                                  Fcst
                                  <br />
                                  Rooms
                                </th>
                                <th className="text-center">Occ%</th>
                                <th className="text-right">
                                  Fcst
                                  <br />
                                  Revenue
                                </th>
                                <th className="text-right border_right">
                                  Fcst
                                  <br />
                                  ADR
                                </th>

                                {/* STLY Sub-columns */}
                                {showSTLY && (
                                  <>
                                    <th className="stly-group-head text-center">
                                      STLY
                                      <br />
                                      ROOMS
                                    </th>
                                    <th className="stly-group-head text-right">
                                      STLY
                                      <br />
                                      ADR
                                    </th>
                                    <th className="stly-group-head text-right border_right">
                                      STLY
                                      <br />
                                      REV
                                    </th>

                                    <th className="stly-group-head-var text-center">
                                      Δ RMS
                                      <br />
                                      VS STLY
                                    </th>
                                    <th className="stly-group-head-var text-right">
                                      Δ ADR
                                      <br />
                                      VS STLY
                                    </th>
                                    <th className="stly-group-head-var text-right border_right">
                                      Δ REV
                                      <br />
                                      VS STLY
                                    </th>
                                  </>
                                )}

                                {/* Total LY Sub-columns */}
                                {showLY && (
                                  <>
                                    <th
                                      colSpan={2}
                                      className="ly-group-head text-center"
                                    >
                                      LY
                                      <br />
                                      ROOMS
                                    </th>
                                    <th className="ly-group-head text-right">
                                      LY
                                      <br />
                                      ADR
                                    </th>
                                    <th className="ly-group-head text-right border_right">
                                      LY
                                      <br />
                                      REV
                                    </th>

                                    <th className="ly-group-head-var text-center">
                                      Δ RMS
                                      <br />
                                      VS LY
                                    </th>
                                    <th className="ly-group-head-var text-right">
                                      Δ ADR
                                      <br />
                                      VS LY
                                    </th>
                                    <th className="ly-group-head-var text-right border_right">
                                      Δ REV
                                      <br />
                                      VS LY
                                    </th>
                                  </>
                                )}
                                {segFilter === "all" ? (
                                  <>
                                    {sortedSegments.map((s) => (
                                      <React.Fragment key={s.key}>
                                        {viewMode !== "revenue_only" && (
                                          <th
                                            className={`seg-head text-center ${viewMode === "rooms_only" ? "seg-last-col border_right" : ""}`}
                                          >
                                            RMS
                                          </th>
                                        )}
                                        {viewMode !== "rooms_only" && (
                                          <th
                                            className={`seg-head text-center ${viewMode !== "adr" ? "seg-last-col border_right" : ""}`}
                                          >
                                            REV
                                          </th>
                                        )}
                                        {viewMode === "adr" && (
                                          <th className="seg-head text-center seg-last-col border_right">
                                            ADR
                                          </th>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </>
                                ) : (
                                  <>
                                    <th className="seg-head text-center">
                                      ROOMS
                                    </th>
                                    <th className="seg-head text-center">
                                      REV
                                    </th>
                                    <th className="seg-head text-center seg-last-col">
                                      ADR
                                    </th>
                                  </>
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {/* Totals Row */}
                              <tr className="shadowOnHover total-row">
                                <td
                                  colSpan={3}
                                  className="boldTd td-total border_right"
                                >
                                  TOTAL
                                </td>
                                {(() => {
                                  const orgOtbTotal = activeOrgMonthRows.reduce(
                                    (a, r) => a + (r.otb || 0),
                                    0,
                                  );
                                  const orgRevTotal = activeOrgMonthRows.reduce(
                                    (a, r) => a + (r.rev || 0),
                                    0,
                                  );
                                  const orgOccSum = activeOrgMonthRows.reduce(
                                    (a, r) => a + (r.occ || 0),
                                    0,
                                  );
                                  const orgOccAvg =
                                    activeOrgMonthRows.length > 0
                                      ? orgOccSum / activeOrgMonthRows.length
                                      : 0;
                                  return (
                                    <>
                                      <td className="boldTd text-center">
                                        {fmtNum(orgOtbTotal)}
                                      </td>
                                      <td className="boldTd text-right">
                                        {fmtDollar(orgRevTotal, 0)}
                                      </td>
                                      <td className="boldTd text-center border_right">
                                        {orgOccAvg
                                          ? Math.round(orgOccAvg) + "%"
                                          : "0%"}
                                      </td>
                                    </>
                                  );
                                })()}
                                {/* <td className="boldTd">{fmtNum(activeMonthRooms)}</td> */}
                                <td className="boldTd">
                                  {(() => {
                                    const ov =
                                      totalOverrides[activeMonth] || {};
                                    const val =
                                      ov.paidRooms !== undefined
                                        ? ov.paidRooms
                                        : Math.round(activeMonthPaidRooms);
                                    return (
                                      <input
                                        type="number"
                                        className="form-control form-control-sm text-center override-input"
                                        style={{
                                          width: "60px",
                                          padding: "2px",
                                          height: "24px",
                                          fontSize: "11px",
                                          display: "inline-block",
                                          backgroundColor:
                                            ov.paidRooms !== undefined
                                              ? "#fef3c7"
                                              : "white",
                                        }}
                                        value={val}
                                        onChange={(e) =>
                                          handleTotalEdit(
                                            activeMonth,
                                            "paidRooms",
                                            e.target.value,
                                          )
                                        }
                                      />
                                    );
                                  })()}
                                </td>
                                <td className="boldTd">
                                  {(() => {
                                    const ov =
                                      totalOverrides[activeMonth] || {};
                                    const val =
                                      ov.occ !== undefined
                                        ? ov.occ
                                        : Number(activeMonthOcc.toFixed(1));
                                    return (
                                      <div className="d-flex align-items-center justify-content-center">
                                        <input
                                          type="number"
                                          className="form-control form-control-sm text-center override-input"
                                          style={{
                                            width: "60px",
                                            padding: "2px",
                                            height: "24px",
                                            fontSize: "11px",
                                            display: "inline-block",
                                            backgroundColor:
                                              ov.occ !== undefined
                                                ? "#fef3c7"
                                                : "white",
                                          }}
                                          value={val}
                                          onChange={(e) =>
                                            handleTotalEdit(
                                              activeMonth,
                                              "occ",
                                              e.target.value,
                                            )
                                          }
                                        />
                                      </div>
                                    );
                                  })()}
                                </td>
                                {viewMode !== "rooms_only" && (
                                  <>
                                    <td className="boldTd text-right">
                                      {(() => {
                                        const ov =
                                          totalOverrides[activeMonth] || {};
                                        const val =
                                          ov.rev !== undefined
                                            ? ov.rev
                                            : Math.round(activeMonthGrossRev);
                                        return (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm text-center override-input"
                                            style={{
                                              width: "70px",
                                              padding: "2px",
                                              height: "24px",
                                              fontSize: "11px",
                                              display: "inline-block",
                                              backgroundColor:
                                                ov.rev !== undefined
                                                  ? "#fef3c7"
                                                  : "white",
                                            }}
                                            value={val}
                                            onChange={(e) =>
                                              handleTotalEdit(
                                                activeMonth,
                                                "rev",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        );
                                      })()}
                                    </td>
                                    <td className="boldTd text-right border_right">
                                      {(() => {
                                        const ov =
                                          totalOverrides[activeMonth] || {};
                                        const val =
                                          ov.adr !== undefined
                                            ? ov.adr
                                            : Number(activeMonthADR.toFixed(2));
                                        return (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm text-center override-input"
                                            style={{
                                              width: "60px",
                                              padding: "2px",
                                              height: "24px",
                                              fontSize: "11px",
                                              display: "inline-block",
                                              backgroundColor:
                                                ov.adr !== undefined
                                                  ? "#fef3c7"
                                                  : "white",
                                            }}
                                            value={val}
                                            onChange={(e) =>
                                              handleTotalEdit(
                                                activeMonth,
                                                "adr",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        );
                                      })()}
                                    </td>
                                  </>
                                )}
                                {(() => {
                                  const lyFcstRoomsTotal =
                                    activeLYForecastMonthRows.reduce(
                                      (a, r) => a + (r.rooms || 0),
                                      0,
                                    );
                                  const lyFcstRevTotal =
                                    activeLYForecastMonthRows.reduce(
                                      (a, r) => a + (r.rev || 0),
                                      0,
                                    );
                                  const lyFcstOcc =
                                    activeMonthAvail > 0
                                      ? (lyFcstRoomsTotal / activeMonthAvail) *
                                        100
                                      : 0;
                                  const lyFcstADRTotal =
                                    lyFcstRoomsTotal > 0
                                      ? lyFcstRevTotal / lyFcstRoomsTotal
                                      : 0;
                                  return (
                                    <>
                                      <td className="boldTd text-center">
                                        {fmtNum(lyFcstRoomsTotal)}
                                      </td>
                                      <td className="boldTd text-center">
                                        {fmtPct(lyFcstOcc)}
                                      </td>
                                      <td className="boldTd text-right">
                                        {fmtDollar(lyFcstRevTotal, 0)}
                                      </td>
                                      <td className="boldTd text-right border_right">
                                        {fmtDollar(lyFcstADRTotal, 2)}
                                      </td>
                                    </>
                                  );
                                })()}
                                {showSTLY &&
                                  (() => {
                                    const stlyRoomsTotal =
                                      activeSTLYMonthRows.reduce(
                                        (a, r) => a + r.paidRooms,
                                        0,
                                      );
                                    const stlyRevTotal =
                                      activeSTLYMonthRows.reduce(
                                        (a, r) => a + r.rev,
                                        0,
                                      );
                                    const stlyADRTotal =
                                      stlyRoomsTotal > 0
                                        ? stlyRevTotal / stlyRoomsTotal
                                        : 0;
                                    return (
                                      <>
                                        <td className="boldTd val-ly">
                                          {fmtNum(stlyRoomsTotal)}
                                        </td>
                                        <td className="boldTd val-ly text-right">
                                          {fmtDollar(stlyADRTotal, 2)}
                                        </td>
                                        <td className="boldTd val-ly text-right border_right">
                                          {fmtDollar(stlyRevTotal, 0)}
                                        </td>
                                        <td
                                          className={`boldTd ${
                                            activeMonthPaidRooms -
                                              stlyRoomsTotal >
                                            0
                                              ? "val-var-pos"
                                              : "val-var-neg"
                                          }`}
                                        >
                                          {activeMonthPaidRooms -
                                            stlyRoomsTotal >
                                          0
                                            ? "+"
                                            : ""}
                                          {fmtNum(
                                            activeMonthPaidRooms -
                                              stlyRoomsTotal,
                                          )}
                                        </td>
                                        <td
                                          className={`boldTd ${activeMonthADR - stlyADRTotal > 0 ? "val-var-pos" : "val-var-neg"} text-right`}
                                        >
                                          {activeMonthADR - stlyADRTotal > 0
                                            ? "+"
                                            : ""}
                                          {fmtDollar(
                                            activeMonthADR - stlyADRTotal,
                                            2,
                                          )}
                                        </td>
                                        <td
                                          className={`boldTd ${activeMonthGrossRev - stlyRevTotal > 0 ? "val-var-pos" : "val-var-neg"} text-right border_right`}
                                        >
                                          {activeMonthGrossRev - stlyRevTotal >
                                          0
                                            ? "+"
                                            : ""}
                                          {fmtDollar(
                                            activeMonthGrossRev - stlyRevTotal,
                                            0,
                                          )}
                                        </td>
                                      </>
                                    );
                                  })()}
                                {showLY &&
                                  (() => {
                                    const lyRoomsTotal =
                                      activeLYMonthRows.reduce(
                                        (a, r) => a + r.paidRooms,
                                        0,
                                      );
                                    const lyRevTotal = activeLYMonthRows.reduce(
                                      (a, r) => a + r.rev,
                                      0,
                                    );
                                    const lyADRTotal =
                                      lyRoomsTotal > 0
                                        ? lyRevTotal / lyRoomsTotal
                                        : 0;
                                    return (
                                      <>
                                        <td className="boldTd val-ly"></td>
                                        <td className="boldTd val-ly">
                                          {fmtNum(lyRoomsTotal)}
                                        </td>
                                        <td className="boldTd val-ly text-right">
                                          {fmtDollar(lyADRTotal, 2)}
                                        </td>
                                        {viewMode !== "rooms_only" && (
                                          <td className="boldTd val-ly text-right border_right">
                                            {fmtDollar(lyRevTotal, 0)}
                                          </td>
                                        )}
                                        <td
                                          className={`boldTd ${
                                            //  activeMonthRooms - lyRoomsTotal > 0
                                            activeMonthPaidRooms -
                                              lyRoomsTotal >
                                            0
                                              ? "val-var-pos"
                                              : "val-var-neg"
                                          }`}
                                        >
                                          {/* {activeMonthRooms - lyRoomsTotal > 0 */}
                                          {activeMonthPaidRooms - lyRoomsTotal >
                                          0
                                            ? "+"
                                            : ""}
                                          {fmtNum(
                                            //  activeMonthRooms - lyRoomsTotal,
                                            activeMonthPaidRooms - lyRoomsTotal,
                                          )}
                                        </td>
                                        <td
                                          className={`boldTd ${activeMonthADR - lyADRTotal > 0 ? "val-var-pos" : "val-var-neg"} text-right`}
                                        >
                                          {activeMonthADR - lyADRTotal > 0
                                            ? "+"
                                            : ""}
                                          {fmtDollar(
                                            activeMonthADR - lyADRTotal,
                                            2,
                                          )}
                                        </td>
                                        {viewMode !== "rooms_only" && (
                                          <td
                                            className={`boldTd ${activeMonthGrossRev - lyRevTotal > 0 ? "val-var-pos" : "val-var-neg"} text-right border_right`}
                                          >
                                            {activeMonthGrossRev - lyRevTotal >
                                            0
                                              ? "+"
                                              : ""}
                                            {fmtDollar(
                                              activeMonthGrossRev - lyRevTotal,
                                              0,
                                            )}
                                          </td>
                                        )}
                                      </>
                                    );
                                  })()}
                                {segFilter === "all" ? (
                                  <>
                                    {sortedSegments.map((s) => {
                                      const segRms = activeMonthRows.reduce(
                                        (a, r) =>
                                          a + (r.segs[s.key]?.rooms || 0),
                                        0,
                                      );
                                      const segRev = activeMonthRows.reduce(
                                        (a, r) => a + (r.segs[s.key]?.rev || 0),
                                        0,
                                      );
                                      const segAdr =
                                        segRms > 0 ? segRev / segRms : 0;
                                      return (
                                        <React.Fragment key={s.key}>
                                          {viewMode !== "revenue_only" && (
                                            <td
                                              className={`boldTd ${
                                                viewMode === "rooms_only"
                                                  ? "seg-last-col border_right"
                                                  : ""
                                              }`}
                                            >
                                              {(() => {
                                                const ov =
                                                  totalOverrides[activeMonth] ||
                                                  {};
                                                const field = `seg_${s.key}_rooms`;
                                                const val =
                                                  ov[field] !== undefined
                                                    ? ov[field]
                                                    : Math.round(segRms);
                                                return (
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "60px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov[field] !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={val}
                                                    onChange={(e) =>
                                                      handleTotalEdit(
                                                        activeMonth,
                                                        field,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                );
                                              })()}
                                            </td>
                                          )}
                                          {viewMode !== "rooms_only" && (
                                            <td
                                              className={`boldTd text-right ${viewMode !== "adr" ? "seg-last-col border_right" : ""}`}
                                            >
                                              {(() => {
                                                const ov =
                                                  totalOverrides[activeMonth] ||
                                                  {};
                                                const field = `seg_${s.key}_rev`;
                                                const val =
                                                  ov[field] !== undefined
                                                    ? ov[field]
                                                    : Math.round(segRev);
                                                return (
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "70px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov[field] !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={val}
                                                    onChange={(e) =>
                                                      handleTotalEdit(
                                                        activeMonth,
                                                        field,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                );
                                              })()}
                                            </td>
                                          )}
                                          {viewMode === "adr" && (
                                            <td className="boldTd text-right seg-last-col border_right">
                                              {(() => {
                                                const ov =
                                                  totalOverrides[activeMonth] ||
                                                  {};
                                                const field = `seg_${s.key}_adr`;
                                                const val =
                                                  ov[field] !== undefined
                                                    ? ov[field]
                                                    : Number(segAdr.toFixed(2));
                                                return (
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "60px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov[field] !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={val}
                                                    onChange={(e) =>
                                                      handleTotalEdit(
                                                        activeMonth,
                                                        field,
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                );
                                              })()}
                                            </td>
                                          )}
                                        </React.Fragment>
                                      );
                                    })}
                                  </>
                                ) : (
                                  (() => {
                                    const segRms = activeMonthRows.reduce(
                                      (a, r) =>
                                        a + (r.segs[segFilter]?.rooms || 0),
                                      0,
                                    );
                                    const segRev = activeMonthRows.reduce(
                                      (a, r) =>
                                        a + (r.segs[segFilter]?.rev || 0),
                                      0,
                                    );
                                    return (
                                      <>
                                        <td className="boldTd">
                                          {(() => {
                                            const ov =
                                              totalOverrides[activeMonth] || {};
                                            const field = `seg_${segFilter}_rooms`;
                                            const val =
                                              ov[field] !== undefined
                                                ? ov[field]
                                                : Math.round(segRms);
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov[field] !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={val}
                                                onChange={(e) =>
                                                  handleTotalEdit(
                                                    activeMonth,
                                                    field,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                        <td className="boldTd text-right">
                                          {(() => {
                                            const ov =
                                              totalOverrides[activeMonth] || {};
                                            const field = `seg_${segFilter}_rev`;
                                            const val =
                                              ov[field] !== undefined
                                                ? ov[field]
                                                : Math.round(segRev);
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "70px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov[field] !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={val}
                                                onChange={(e) =>
                                                  handleTotalEdit(
                                                    activeMonth,
                                                    field,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                        <td className="boldTd seg-last-col text-right border_right">
                                          {(() => {
                                            const ov =
                                              totalOverrides[activeMonth] || {};
                                            const field = `seg_${segFilter}_adr`;
                                            const segAdr =
                                              segRms > 0 ? segRev / segRms : 0;
                                            const val =
                                              ov[field] !== undefined
                                                ? ov[field]
                                                : Number(segAdr.toFixed(2));
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov[field] !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={val}
                                                onChange={(e) =>
                                                  handleTotalEdit(
                                                    activeMonth,
                                                    field,
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                      </>
                                    );
                                  })()
                                )}
                              </tr>
                              {activeMonthRows.map((r, dayIdx) => {
                                const lyDay = showLY
                                  ? getLYDay(activeMonth, r.day)
                                  : null;
                                const stlyDay = showSTLY
                                  ? getSTLYDay(activeMonth, r.day)
                                  : null;
                                const wkndCls = r.wknd ? "weekend" : "";
                                const itemDate = new Date(
                                  year,
                                  activeMonth,
                                  r.day,
                                );
                                const checkEvent = eventListRef.current?.filter(
                                  (x) => {
                                    let dateStr =
                                      commonService.getDateInFormat(itemDate);
                                    return (
                                      dateStr >=
                                        commonService.getDateInFormat(
                                          x.startDate,
                                        ) &&
                                      dateStr <=
                                        commonService.getDateInFormat(x.endDate)
                                    );
                                  },
                                );
                                let lyCheckEvent = [];
                                if (lyDay?.lyDates?.length > 0) {
                                  lyCheckEvent = eventListRef.current?.filter((x) => {
                                    return lyDay.lyDates.some((lyDate) => {
                                      // If lyDate is "YYYY-MM-DD", Moment(lyDate) parses it properly without timezone shifts
                                      let localDateObj = moment(lyDate, "YYYY-MM-DD").toDate();
                                      let dateStr = commonService.getDateInFormat(localDateObj);
                                      return (
                                        dateStr >= commonService.getDateInFormat(x.startDate) &&
                                        dateStr <= commonService.getDateInFormat(x.endDate)
                                      );
                                    });
                                  });
                                }
                                return (
                                  <tr key={dayIdx} className={wkndCls}>
                                    <td
                                      className={`${r.wknd ? "weekend-flag" : ""} td-dow`}
                                    >
                                      {moment(itemDate).format("MM/DD/YYYY")}
                                    </td>
                                    <td
                                      className={`${r.wknd ? "weekend-flag" : ""} td-dow`}
                                    >
                                      {DOW_LABELS[r.dow]}
                                    </td>
                                    <td
                                      className={`${r.wknd ? "weekend-flag" : ""} td-dow border_right`}
                                    >
                                      <div className="d-flex justify-content-center align-items-center ticketAlarmReload">
                                        {checkEvent?.length > 0 && (
                                          <img
                                            style={{
                                              height: "11px",
                                              width: "11px",
                                              cursor: "pointer",
                                            }}
                                            className="iconcolor"
                                            src={ticket}
                                            alt="ticket"
                                            id={commonService.generateGlobalClickTrackerID(
                                              "UserSimulator",
                                              "checkEventIcon",
                                              commonService.getDateInFormat(
                                                itemDate,
                                              ),
                                            )}
                                            onClick={() => {
                                              selectedEventDateRef.current =
                                                itemDate;
                                              eventListPropsRef.current =
                                                checkEvent;
                                              setShowTicketModal(true);
                                            }}
                                          />
                                        )}
                                      </div>
                                    </td>
                                    {(() => {
                                      const orgDay = activeOrgMonthRows[dayIdx];
                                      return (
                                        <>
                                          <td className="text-center">
                                            {fmtNum(orgDay?.otb)}
                                          </td>
                                          <td className="text-right">
                                            {fmtDollar(orgDay?.rev, 0)}
                                          </td>
                                          <td className="text-center border_right">
                                            {orgDay?.occ
                                              ? Math.round(orgDay.occ) + "%"
                                              : "0%"}
                                          </td>
                                        </>
                                      );
                                    })()}
                                    <td className="val-rooms">
                                      {(() => {
                                        const ov =
                                          dayOverrides[activeMonth]?.[r.day] ||
                                          {};
                                        const valRooms =
                                          ov.paidRooms !== undefined
                                            ? ov.paidRooms
                                            : Math.round(r.paidRooms);
                                        return (
                                          <input
                                            type="number"
                                            className="form-control form-control-sm text-center override-input"
                                            style={{
                                              width: "60px",
                                              padding: "2px",
                                              height: "24px",
                                              fontSize: "11px",
                                              display: "inline-block",
                                              backgroundColor:
                                                ov.paidRooms !== undefined
                                                  ? "#fef3c7"
                                                  : "white",
                                            }}
                                            value={valRooms}
                                            onChange={(e) =>
                                              handleDayEdit(
                                                activeMonth,
                                                r.day,
                                                "paidRooms",
                                                e.target.value,
                                              )
                                            }
                                          />
                                        );
                                      })()}
                                    </td>
                                    <td className="val-occ">
                                      {(() => {
                                        const ov =
                                          dayOverrides[activeMonth]?.[r.day] ||
                                          {};
                                        const valOcc =
                                          ov.occ !== undefined
                                            ? ov.occ
                                            : Number(r.occ.toFixed(1));
                                        return (
                                          <div className="d-flex align-items-center justify-content-center">
                                            <input
                                              type="number"
                                              className="form-control form-control-sm text-center override-input"
                                              style={{
                                                width: "60px",
                                                padding: "2px",
                                                height: "24px",
                                                fontSize: "11px",
                                                display: "inline-block",
                                                backgroundColor:
                                                  ov.occ !== undefined
                                                    ? "#fef3c7"
                                                    : "white",
                                              }}
                                              value={valOcc}
                                              onChange={(e) =>
                                                handleDayEdit(
                                                  activeMonth,
                                                  r.day,
                                                  "occ",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                          </div>
                                        );
                                      })()}
                                    </td>
                                    {viewMode !== "rooms_only" && (
                                      <>
                                        <td className="val-rev text-right">
                                          {(() => {
                                            const ov =
                                              dayOverrides[activeMonth]?.[
                                                r.day
                                              ] || {};
                                            const valRev =
                                              ov.rev !== undefined
                                                ? ov.rev
                                                : Math.round(r.rev);
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "70px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.rev !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valRev}
                                                onChange={(e) =>
                                                  handleDayEdit(
                                                    activeMonth,
                                                    r.day,
                                                    "rev",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                        <td className="val-adr text-right border_right">
                                          {(() => {
                                            const ov =
                                              dayOverrides[activeMonth]?.[
                                                r.day
                                              ] || {};
                                            const valAdr =
                                              ov.adr !== undefined
                                                ? ov.adr
                                                : Number(r.adr.toFixed(2));
                                            return (
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.adr !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valAdr}
                                                onChange={(e) =>
                                                  handleDayEdit(
                                                    activeMonth,
                                                    r.day,
                                                    "adr",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            );
                                          })()}
                                        </td>
                                      </>
                                    )}
                                    {(() => {
                                      const fcstDay = getLyForecastDay(
                                        activeMonth,
                                        r.day,
                                      );
                                      return (
                                        <>
                                          <td className="text-center">
                                            {fmtNum(fcstDay?.rooms)}
                                          </td>
                                          <td className="text-center">
                                            {fmtPct(fcstDay?.occ)}
                                          </td>
                                          <td className="text-right">
                                            {fmtDollar(fcstDay?.rev, 0)}
                                          </td>
                                          <td className="text-right border_right">
                                            {fmtDollar(fcstDay?.adr, 2)}
                                          </td>
                                        </>
                                      );
                                    })()}
                                    {showSTLY &&
                                      (stlyDay ? (
                                        <>
                                          <td className="val-ly">
                                            {fmtNum(stlyDay.rooms)}
                                          </td>
                                          <td className="val-ly text-right">
                                            {fmtDollar(stlyDay.adr, 2)}
                                          </td>
                                          <td className="val-ly text-right border_right">
                                            {fmtDollar(stlyDay.rev, 0)}
                                          </td>
                                          {/* Variance */}
                                          <td
                                            className={
                                              r.paidRooms - stlyDay.rooms > 0
                                                ? "val-var-pos font-weight-bold"
                                                : r.paidRooms - stlyDay.rooms <
                                                    0
                                                  ? "val-var-neg font-weight-bold"
                                                  : "val-var-neu font-weight-bold"
                                            }
                                            style={{
                                              color:
                                                r.paidRooms - stlyDay.rooms > 0
                                                  ? "#16A34A"
                                                  : "inherit",
                                            }}
                                          >
                                            {r.paidRooms - stlyDay.rooms > 0
                                              ? "+"
                                              : ""}
                                            {fmtNum(
                                              r.paidRooms - stlyDay.rooms,
                                            )}
                                          </td>
                                          <td
                                            className={`${r.adr - stlyDay.adr > 0 ? "val-var-pos" : r.adr - stlyDay.adr < 0 ? "val-var-neg" : "val-var-neu"} text-right font-weight-bold`}
                                            style={{
                                              color:
                                                r.adr - stlyDay.adr > 0
                                                  ? "#16A34A"
                                                  : "inherit",
                                            }}
                                          >
                                            {r.adr - stlyDay.adr > 0 ? "+" : ""}
                                            {fmtDollar(r.adr - stlyDay.adr, 2)}
                                          </td>
                                          <td
                                            className={`${r.rev - stlyDay.rev > 0 ? "val-var-pos" : r.rev - stlyDay.rev < 0 ? "val-var-neg" : "val-var-neu"} text-right border_right font-weight-bold`}
                                            style={{
                                              color:
                                                r.rev - stlyDay.rev > 0
                                                  ? "#16A34A"
                                                  : "inherit",
                                            }}
                                          >
                                            {r.rev - stlyDay.rev > 0 ? "+" : ""}
                                            {fmtDollar(r.rev - stlyDay.rev, 0)}
                                          </td>
                                        </>
                                      ) : (
                                        <td
                                          colSpan={6}
                                          className="td-no-data border_right"
                                        >
                                          no STLY data
                                        </td>
                                      ))}
                                    {showLY &&
                                      (lyDay ? (
                                        <>
                                          <td>
                                              <div className="d-flex justify-content-center align-items-center ticketAlarmReload">
                                              {lyCheckEvent?.length > 0 && (
                                                <img
                                                  style={{
                                                    height: "11px",
                                                    width: "11px",
                                                    cursor: "pointer",
                                                  }}
                                                  className="iconcolor"
                                                  src={ticket}
                                                  alt="ticket"
                                                  id={commonService.generateGlobalClickTrackerID(
                                                    "UserSimulator",
                                                    "checkEventIcon",
                                                    commonService.getDateInFormat(
                                                      itemDate,
                                                    ),
                                                  )}
                                                  onClick={() => {
                                                    // Parse it explicitly in local timezone to avoid UTC shift
                                                    selectedEventDateRef.current = lyDay?.lyDates?.[0] ? moment(lyDay.lyDates[0], "YYYY-MM-DD").toDate() : itemDate;
                                                    eventListPropsRef.current = lyCheckEvent;
                                                    setShowTicketModal(true);
                                                  }}
                                                />
                                              )}
                                            </div>
                                          </td>
                                          <td className="val-ly">
                                            {fmtNum(lyDay.rooms)}
                                          </td>
                                          <td className="val-ly text-right">
                                            {fmtDollar(lyDay.adr, 2)}
                                          </td>
                                          <td className="val-ly text-right border_right">
                                            {fmtDollar(lyDay.rev, 0)}
                                          </td>
                                          {/* Variance */}
                                          <td
                                            className={
                                              r.paidRooms - lyDay.rooms > 0
                                                ? "val-var-pos font-weight-bold"
                                                : r.paidRooms - lyDay.rooms < 0
                                                  ? "val-var-neg font-weight-bold"
                                                  : "val-var-neu font-weight-bold"
                                            }
                                            style={{
                                              color:
                                                r.paidRooms - lyDay.rooms > 0
                                                  ? "#16A34A"
                                                  : "inherit",
                                            }}
                                          >
                                            {r.paidRooms - lyDay.rooms > 0
                                              ? "+"
                                              : ""}
                                            {fmtNum(r.paidRooms - lyDay.rooms)}
                                          </td>
                                          <td
                                            className={`${r.adr - lyDay.adr > 0 ? "val-var-pos" : r.adr - lyDay.adr < 0 ? "val-var-neg" : "val-var-neu"} text-right font-weight-bold`}
                                            style={{
                                              color:
                                                r.adr - lyDay.adr > 0
                                                  ? "#16A34A"
                                                  : "inherit",
                                            }}
                                          >
                                            {r.adr - lyDay.adr > 0 ? "+" : ""}
                                            {fmtDollar(r.adr - lyDay.adr, 2)}
                                          </td>
                                          <td
                                            className={`${r.rev - lyDay.rev > 0 ? "val-var-pos" : r.rev - lyDay.rev < 0 ? "val-var-neg" : "val-var-neu"} text-right border_right font-weight-bold`}
                                            style={{
                                              color:
                                                r.rev - lyDay.rev > 0
                                                  ? "#16A34A"
                                                  : "inherit",
                                            }}
                                          >
                                            {r.rev - lyDay.rev > 0 ? "+" : ""}
                                            {fmtDollar(r.rev - lyDay.rev, 0)}
                                          </td>
                                        </>
                                      ) : (
                                        <td colSpan={7} className="td-no-data">
                                          no LY data
                                        </td>
                                      ))}
                                    {segFilter === "all" ? (
                                      <>
                                        {sortedSegments.map((s) => {
                                          const baseRooms = Math.round(
                                            r.segs[s.key]?.rooms || 0,
                                          );
                                          const baseRev = Math.round(
                                            r.segs[s.key]?.rev || 0,
                                          );
                                          const baseAdr =
                                            r.segs[s.key]?.adr || 0;
                                          const ov =
                                            segmentOverrides[activeMonth]?.[
                                              r.day
                                            ]?.[s.key] || {};

                                          const valRooms =
                                            ov.rooms !== undefined
                                              ? ov.rooms
                                              : baseRooms;
                                          const valRev =
                                            ov.rev !== undefined
                                              ? ov.rev
                                              : baseRev;
                                          const valAdr =
                                            ov.adr !== undefined
                                              ? ov.adr
                                              : Number(baseAdr.toFixed(2));

                                          return (
                                            <React.Fragment key={s.key}>
                                              {viewMode !== "revenue_only" && (
                                                <td
                                                  className={`seg-${s.key} val-rooms ${viewMode === "rooms_only" ? "seg-last-col border_right" : ""}`}
                                                >
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "60px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov.rooms !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={valRooms}
                                                    onChange={(e) =>
                                                      handleSegmentEdit(
                                                        activeMonth,
                                                        r.day,
                                                        s.key,
                                                        "rooms",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                              {viewMode !== "rooms_only" && (
                                                <td
                                                  className={`seg-${s.key} val-rev text-right ${viewMode !== "adr" ? "seg-last-col border_right" : ""}`}
                                                >
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "70px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov.rev !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={valRev}
                                                    onChange={(e) =>
                                                      handleSegmentEdit(
                                                        activeMonth,
                                                        r.day,
                                                        s.key,
                                                        "rev",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                              {viewMode === "adr" && (
                                                <td
                                                  className={`seg-${s.key} val-adr text-right seg-last-col border_right`}
                                                >
                                                  <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center override-input"
                                                    style={{
                                                      width: "65px",
                                                      padding: "2px",
                                                      height: "24px",
                                                      fontSize: "11px",
                                                      display: "inline-block",
                                                      backgroundColor:
                                                        ov.adr !== undefined
                                                          ? "#fef3c7"
                                                          : "white",
                                                    }}
                                                    value={valAdr}
                                                    step="0.01"
                                                    onChange={(e) =>
                                                      handleSegmentEdit(
                                                        activeMonth,
                                                        r.day,
                                                        s.key,
                                                        "adr",
                                                        e.target.value,
                                                      )
                                                    }
                                                  />
                                                </td>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </>
                                    ) : (
                                      (() => {
                                        const sKey = segFilter;
                                        const baseRooms = Math.round(
                                          r.segs[sKey]?.rooms || 0,
                                        );
                                        const baseRev = Math.round(
                                          r.segs[sKey]?.rev || 0,
                                        );
                                        const baseAdr = r.segs[sKey]?.adr || 0;
                                        const ov =
                                          segmentOverrides[activeMonth]?.[
                                            r.day
                                          ]?.[sKey] || {};

                                        const valRooms =
                                          ov.rooms !== undefined
                                            ? ov.rooms
                                            : baseRooms;
                                        const valRev =
                                          ov.rev !== undefined
                                            ? ov.rev
                                            : baseRev;
                                        const valAdr =
                                          ov.adr !== undefined
                                            ? ov.adr
                                            : Number(baseAdr.toFixed(2));

                                        return (
                                          <>
                                            <td className="val-rooms">
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "60px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.rooms !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valRooms}
                                                onChange={(e) =>
                                                  handleSegmentEdit(
                                                    activeMonth,
                                                    r.day,
                                                    sKey,
                                                    "rooms",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td className="val-rev text-right">
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "70px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.rev !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valRev}
                                                onChange={(e) =>
                                                  handleSegmentEdit(
                                                    activeMonth,
                                                    r.day,
                                                    sKey,
                                                    "rev",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                            <td className="val-adr text-right seg-last-col">
                                              <input
                                                type="number"
                                                className="form-control form-control-sm text-center override-input"
                                                style={{
                                                  width: "65px",
                                                  padding: "2px",
                                                  height: "24px",
                                                  fontSize: "11px",
                                                  display: "inline-block",
                                                  backgroundColor:
                                                    ov.adr !== undefined
                                                      ? "#fef3c7"
                                                      : "white",
                                                }}
                                                value={valAdr}
                                                step="0.01"
                                                onChange={(e) =>
                                                  handleSegmentEdit(
                                                    activeMonth,
                                                    r.day,
                                                    sKey,
                                                    "adr",
                                                    e.target.value,
                                                  )
                                                }
                                              />
                                            </td>
                                          </>
                                        );
                                      })()
                                    )}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* RIGHT PANEL (Assumptions & Summary) */}
                  <div className="right-panel d-flex flex-column us-style-7">
                    {/* NEW FORECAST DRIVERS SECTION */}
                    <div className="forecast-drivers-section us-style-8">
                      <h5 className="fw-bold mb-2 us-style-9">
                        Forecast Drivers
                      </h5>
                      <p className="text-muted mb-4 us-style-10">
                        Base is the <strong>system forecast</strong>. Sliders
                        move it up or down from the signals below. Reset returns
                        every driver to 0 (pure system forecast).
                      </p>

                      {/* DEMAND ADJUSTMENT */}
                      <div className="mb-4">
                        <span className="badge mb-3 d-inline-flex align-items-center us-style-11">
                          {/* <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="me-1"
                          >
                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                          </svg> */}
                          DEMAND ADJUSTMENT
                        </span>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="fw-bold m-0 us-style-12">
                              Occupancy override
                            </label>
                            <span className="fw-bold us-style-13">
                              {localOccAdj > 0 ? "+" : ""}
                              {localOccAdj}%
                            </span>
                          </div>
                          <input
                            type="range"
                            className="form-range custom-slider"
                            min="-15"
                            max="15"
                            step="0.5"
                            value={localOccAdj}
                            onChange={(e) =>
                              setLocalOccAdj(Number(e.target.value))
                            }
                            style={{
                              background: `linear-gradient(to right, #2563EB ${((localOccAdj + 15) / 30) * 100}%, #E2E8F0 ${((localOccAdj + 15) / 30) * 100}%)`,
                            }}
                          />
                          <small className="text-muted d-block us-style-14">
                            Shifts occupancy above / below system forecast.
                          </small>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="fw-bold m-0 us-style-12">
                              Pickup pace
                            </label>
                            <span className="fw-bold us-style-13">
                              {localPaceAdj > 0 ? "+" : ""}
                              {localPaceAdj}%
                            </span>
                          </div>
                          <input
                            type="range"
                            className="form-range custom-slider"
                            min="-20"
                            max="20"
                            step="1"
                            value={localPaceAdj}
                            onChange={(e) =>
                              setLocalPaceAdj(Number(e.target.value))
                            }
                            style={{
                              background: `linear-gradient(to right, #2563EB ${((localPaceAdj + 20) / 40) * 100}%, #E2E8F0 ${((localPaceAdj + 20) / 40) * 100}%)`,
                            }}
                          />
                          <small className="text-muted d-block us-style-14">
                            OTB build vs normal DBA pickup curve. Faster pace{" "}
                            {"->"} higher final occupancy.
                          </small>
                        </div>
                      </div>

                      {/* RATE ADJUSTMENT */}
                      <div className="mb-4">
                        <span className="badge mb-3 d-inline-flex align-items-center us-style-11">
                          {/* <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="me-1"
                          >
                            <line x1="12" y1="1" x2="12" y2="23"></line>
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                          </svg> */}
                          RATE ADJUSTMENT
                        </span>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="fw-bold m-0 us-style-12">
                              ADR adjustment
                            </label>
                            <span className="fw-bold us-style-13">
                              {localAdrAdj > 0 ? "+" : ""}
                              {localAdrAdj}%
                            </span>
                          </div>
                          <input
                            type="range"
                            className="form-range custom-slider"
                            min="-15"
                            max="20"
                            step="0.5"
                            value={localAdrAdj}
                            onChange={(e) =>
                              setLocalAdrAdj(Number(e.target.value))
                            }
                            style={{
                              background: `linear-gradient(to right, #2563EB ${((localAdrAdj + 15) / 35) * 100}%, #E2E8F0 ${((localAdrAdj + 15) / 35) * 100}%)`,
                            }}
                          />
                          <small className="text-muted d-block us-style-14">
                            Blended ADR shift across all segments.
                          </small>
                        </div>
                      </div>

                      {/* SIGNAL WEIGHTING */}
                      <div className="mb-4">
                        <span className="badge mb-2 d-inline-flex align-items-center us-style-15">
                          {/* <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="me-1"
                          >
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                          </svg> */}
                          SIGNAL WEIGHTING
                        </span>
                        <p className="text-muted mb-3 us-style-16">
                          How much each historical signal pulls the system base.
                          Higher weight = stronger pull toward that signal.
                        </p>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="fw-bold m-0 us-style-12">
                              STLY weight
                            </label>
                            <span className="fw-bold us-style-13">
                              {localWStly}%
                            </span>
                          </div>
                          <input
                            type="range"
                            className="form-range custom-slider"
                            min="0"
                            max="100"
                            step="5"
                            value={localWStly}
                            onChange={(e) =>
                              setLocalWStly(Number(e.target.value))
                            }
                            style={{
                              background: `linear-gradient(to right, #2563EB ${localWStly}%, #E2E8F0 ${localWStly}%)`,
                            }}
                          />
                          <small className="text-muted d-block us-style-14">
                            Pull toward same-time-last-year pace.
                          </small>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="fw-bold m-0 us-style-12">
                              Last Year weight
                            </label>
                            <span className="fw-bold us-style-13">
                              {localWLy}%
                            </span>
                          </div>
                          <input
                            type="range"
                            className="form-range custom-slider"
                            min="0"
                            max="100"
                            step="5"
                            value={localWLy}
                            onChange={(e) =>
                              setLocalWLy(Number(e.target.value))
                            }
                            style={{
                              background: `linear-gradient(to right, #2563EB ${localWLy}%, #E2E8F0 ${localWLy}%)`,
                            }}
                          />
                          <small className="text-muted d-block us-style-14">
                            Pull toward last-year final actuals.
                          </small>
                        </div>

                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="fw-bold m-0 us-style-12">
                              Pace weight
                            </label>
                            <span className="fw-bold us-style-13">
                              {localWPace}%
                            </span>
                          </div>
                          <input
                            type="range"
                            className="form-range custom-slider"
                            min="0"
                            max="100"
                            step="5"
                            value={localWPace}
                            onChange={(e) =>
                              setLocalWPace(Number(e.target.value))
                            }
                            style={{
                              background: `linear-gradient(to right, #2563EB ${localWPace}%, #E2E8F0 ${localWPace}%)`,
                            }}
                          />
                          <small className="text-muted d-block us-style-14">
                            Pull toward current pickup-pace signal.
                          </small>
                        </div>

                        <p className="text-muted mt-3 mb-3 us-style-16">
                          System base holds the remaining weight. Weights are
                          normalised at run time.
                        </p>

                        <button
                          className="btn w-100 d-flex justify-content-center align-items-center gap-2 us-style-17"
                          onClick={resetDrivers}
                        >
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                            <polyline points="3 3 3 8 8 8"></polyline>
                          </svg>
                          Reset to System Forecast
                        </button>
                      </div>

                      {/* SEGMENT MIX */}
                      <div className="mb-2">
                        <span className="badge mb-3 d-inline-flex align-items-center us-style-11">
                          {/* <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="me-1"
                          >
                            <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                            <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                          </svg> */}
                          SEGMENT MIX
                        </span>

                        {segments.map((item, index) => (
                          <div
                            key={index}
                            className="d-flex justify-content-between align-items-center mb-2 pb-2"
                            style={{
                              borderBottom:
                                index !== segments.length - 1
                                  ? "1px solid #F1F5F9"
                                  : "none",
                            }}
                          >
                            <label className="m-0 text-muted us-style-18">
                              {item.label} %
                            </label>
                            <input
                              type="number"
                              className="form-control text-center p-1"
                              value={mix[item.key] || 0}
                              onChange={(e) =>
                                handleMixChange(item.key, e.target.value)
                              }
                              style={{
                                width: "60px",
                                height: "28px",
                                fontSize: "13px",
                                color: "#1E293B",
                                borderRadius: "4px",
                                border: "1px solid #A5B4FC",
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeMainTab === "summary" && (
              <div className="content tab-pane-summary w-100">
                {/* MAIN LAYOUT */}
                <div className=" us-style-19">
                  {/* SEGMENT SUMMARY CARDS */}
                  <div className="seg-summary-wrapper us-style-20">
                    {/* <div className="seg-summary-title us-style-21">
                  SEGMENT SUMMARY —{" "}
                  <span className="text-uppercase">
                    {MONTHS[activeMonth]} {year}
                  </span>
                </div> */}
                    <div
                      className="seg-cards"
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(120px, 1fr))",
                        gap: "12px",
                      }}
                    >
                      {segmentCardData.map((s) => (
                        <div
                          key={s.key}
                          className="seg-card shadow-sm"
                          style={{
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #E2E8F0",
                            borderTop: `4px solid ${s.color}`,
                            borderRadius: "8px",
                            padding: "12px",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <div
                            className="seg-card-name text-uppercase"
                            style={{
                              color: s.color,
                              fontSize: "10px",
                              fontWeight: "700",
                              letterSpacing: "0.5px",
                              marginBottom: "6px",
                            }}
                          >
                            {s.label}
                          </div>
                          <div
                            className="seg-card-rooms"
                            style={{
                              color: s.color,
                              fontSize: "24px",
                              fontWeight: "bold",
                              lineHeight: "1",
                              marginBottom: "8px",
                            }}
                          >
                            {fmtNum(s.rooms)}
                          </div>
                          <div className="seg-card-rev us-style-22">
                            {fmtDollar(s.rev / 1000, 1)}K
                          </div>
                          <div className="seg-card-adr us-style-23">
                            {fmtDollar(s.adr, 2)} ADR
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* SUMMARY SECTION */}

                  <div className="row">
                    <div className="col-md-6">
                      <div className="chart-card shadow-sm us-style-24">
                        <div className="rp-section mb-0 pb-3">
                          <div className="rp-title mb-3">
                            Month Forecast Summary
                          </div>
                          <div className="budget-simulator-2x2-grid">
                            <div className="budget-simulator-inner-card mb-0">
                              <div className="rp-group-title text-uppercase budget-simulator-ls-5">
                                DEMAND
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  Forecast Rooms
                                </span>
                                <span className="rp-row-val">
                                  {fmtNum(activeMonthRooms)}
                                </span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">Occupancy</span>
                                <span className="rp-row-val">
                                  {fmtPct(activeMonthOcc)}
                                </span>
                              </div>
                            </div>

                            <div className="budget-simulator-inner-card mb-0">
                              <div className="rp-group-title text-uppercase budget-simulator-ls-5">
                                RATE
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  Blended ADR
                                </span>
                                <span className="rp-row-val">
                                  {fmtDollar(activeMonthADR, 2)}
                                </span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">RevPAR</span>
                                <span className="rp-row-val">
                                  {fmtDollar(activeMonthRevPAR, 2)}
                                </span>
                              </div>
                            </div>

                            <div className="budget-simulator-inner-card mb-0">
                              <div className="rp-group-title text-uppercase budget-simulator-ls-5">
                                VS BASELINES
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  RevPAR vs STLY
                                </span>
                                <span className="rp-row-val pos">+5.4%</span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  RevPAR vs LY
                                </span>
                                <span className="rp-row-val pos">+11.1%</span>
                              </div>
                            </div>

                            <div className="budget-simulator-inner-card mb-0">
                              <div className="rp-group-title text-uppercase budget-simulator-ls-5">
                                REVENUE
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  Room Revenue
                                </span>
                                <span className="rp-row-val">
                                  {fmtDollar(activeMonthGrossRev, 0)}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="chart-card shadow-sm us-style-24">
                        <div className="rp-section mb-0">
                          <div className="rp-title mb-3">
                            FY Forecast Totals
                          </div>
                          <div className="budget-simulator-2x2-grid">
                            <div className="budget-simulator-inner-card mb-0">
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  Forecast Rooms
                                </span>
                                <span className="rp-row-val">
                                  {fmtNum(annualOccRooms)}
                                </span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">Occupancy</span>
                                <span className="rp-row-val">
                                  {fmtPct(annualOcc)}
                                </span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">ADR</span>
                                <span className="rp-row-val">
                                  {fmtDollar(annualADR, 2)}
                                </span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">RevPAR</span>
                                <span className="rp-row-val">
                                  {fmtDollar(annualRevPAR, 2)}
                                </span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  RevPAR vs STLY
                                </span>
                                <span className="rp-row-val pos">+5.2%</span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  RevPAR vs LY
                                </span>
                                <span className="rp-row-val pos">+10.9%</span>
                              </div>
                              <div className="rp-row">
                                <span className="rp-row-label">
                                  Room Revenue
                                </span>
                                <span className="rp-row-val">
                                  {fmtDollar(annualRoomRev / 1000, 1)}K
                                </span>
                              </div>
                            </div>

                            <div className="budget-simulator-wiring-box p-3">
                              <p className="m-0 text-muted budget-simulator-wiring-text">
                                <strong className="text-dark">
                                  Wiring points
                                </strong>{" "}
                                — System base loads from{" "}
                                <strong className="text-dark">
                                  monthly_forecast / daybyday_forecast
                                </strong>{" "}
                                insight tables (keyed by AsOfDate). STLY from{" "}
                                <strong className="text-dark">
                                  monthly_actuals_stly
                                </strong>
                                , LY from{" "}
                                <strong className="text-dark">
                                  annual_actuals
                                </strong>
                                . Pace signal from the DBA curve in{" "}
                                <strong className="text-dark">
                                  pace_snapshots
                                </strong>
                                . Segment split from{" "}
                                <strong className="text-dark">
                                  segment_mix_forecast
                                </strong>
                                . Replace BASE[] arrays with live PostgreSQL /
                                BigQuery feeds.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* CHARTS CONTAINER */}
                  <div className="mt-3 us-style-20">
                    <div className="chart-card shadow-sm us-style-24">
                      <div className="rp-title us-style-25">
                        Daily Rooms by Segment
                      </div>
                      <div className="legend us-style-26">
                        {sortedSegments.map((s) => {
                          const isHidden = !!hiddenSegments[s.key];
                          return (
                            <div
                              key={s.key}
                              className="legend-item"
                              onClick={() => toggleSegment(s.key)}
                              style={{
                                cursor: "pointer",
                                textDecoration: isHidden
                                  ? "line-through"
                                  : "none",
                                opacity: isHidden ? 0.4 : 1,
                                display: "flex",
                                alignItems: "center",
                                fontSize: "11px",
                                color: "#475569",
                                fontWeight: "600",
                              }}
                            >
                              <div
                                className="legend-swatch"
                                style={{
                                  backgroundColor: s.color,
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "2px",
                                  marginRight: "6px",
                                }}
                              ></div>
                              {s.label}
                            </div>
                          );
                        })}
                      </div>
                      <div className="chart-canvas-wrapper us-style-27">
                        <Bar data={chart1Data} options={chart1Options} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {showTicketModal && (
        <EventViewModal
          showModal={showTicketModal}
          closeModal={closeTicketModal}
          eventDetails={eventListPropsRef.current}
          selectedDate={selectedEventDateRef.current}
          getEventList={getEventList}
        />
      )}
    </div>
      ) : (
        <div className="d-flex justify-content-center p-5">
          <h5>Please Select Property</h5>
        </div>
      )}
    </>
  );
};

export default UserSimulator;
